import { useState, useEffect, useMemo } from "react";
import Swal from "sweetalert2";
import api from "services/api";
import { useAuth } from "hooks/useAuth";
import { useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import moment from "moment";
import { default as ReactSelect } from "react-select";
import makeAnimated from "react-select/animated";
import emailjs from "emailjs-com";
import { sortDESC, sortMesCompetencia, sortYear } from "utils/sort";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import { useLocation } from "react-router-dom";
import {
  Radio,
  RadioGroup,
  Stack,
  FormControl,
  FormLabel,
  Box,
  Select,
  useMediaQuery,
  Alert,
  AlertIcon,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Grid,
  Input,
  InputGroup,
  Textarea,
  Divider,
  Switch,
  CircularProgress,
  FormErrorMessage,
} from "@chakra-ui/react";
import { BiCommentDetail } from "react-icons/bi";
import { MdFileUpload, MdFileDownload, MdEdit } from "react-icons/md";
import { RiFileTextLine, RiFileEditFill } from "react-icons/ri";
import { FcHighPriority, FcExpired, FcAbout } from "react-icons/fc";
import { AiOutlineReload } from "react-icons/ai";
import { download } from "services/dowloadArquivo";
import { meses } from "utils/meses";
import { baseUrlLink } from "services/baseUrl";

interface Document {
  id: number;
  ano_competencia: number;
  nome_arquivo_s3: string;
  tipo_documento: any;
  operadora: any;
  entidade: any;
  contrato: any;
  mes_competencia: number;
  dt_vencimento: string;
  hist_validacao_docs: any;
  status_documento: any;
  updated_at: Date;
  valor: number;
  fl_envia_pos_limite: boolean;
  hash_arquivo: string;
  created_at: any;
  fl_validando_ext_bol_not: boolean;
  fl_pendencia_ext_bol_not: boolean;
}

interface PessoaJuridica {
  id: number;
  nm_entidade: string;
  cnpj_entidade: string;
  contratoes: any;
  contrato_vinculado: any;
}

const defaultValues = {
  valor: "",
  observacao: "",
};

function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const Cobranca = () => {
  let query = useQuery();
  const [activeStep, setActiveStep] = useState(0);
  const [status, setStatus] = useState<any>("");
  const animatedComponents = makeAnimated();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [pessoasJuridicas, setPessoasJuridicas] = useState<PessoaJuridica[]>(
    [],
  );
  const [usuariosContratos, setUsuariosContratos] = useState<any[]>([]);
  const [contratos, setContratos] = useState<any>([]);
  const [mobile] = useMediaQuery("(max-width: 624px)");
  const [notebook] = useMediaQuery("(max-width: 1366px)");
  const [click, setClick] = useState<string | null>(null);
  const [observacao, setObservacao] = useState<any>(null);
  const [isEditing, setisEditing] = useState<boolean>(false);
  const [isSending, setIsSending] = useState<boolean>(false);
  const [newFile, setNewFile] = useState<boolean>(false);
  const [newFileComp, setNewFileComp] = useState<boolean>(false);
  const [valor, setValor] = useState<any>(null);
  const [inputValorEdit, setInputValorEdit] = useState<any>(null);
  const [emailsUsers, setEmailsUsers] = useState<any>(null);
  const [inputObervacaoEdit, setInputObservacaoEdit] = useState<any>("");
  const [inputFileEdit, setInputFileEdit] = useState<any>(null);
  const [inputFileComp, setInputFileComp] = useState<any>(null);
  const [statusContract, setStatusContract] = useState<any>("ativo");
  const [contractValue, setContractValue] = useState<any>(null);
  const [selectedEntidade, setSelectedEntidade] = useState<any>(
    query.get("pj"),
  ); // Teste 26
  const [selectedContract, setSelectedContract] = useState<any>(
    query.get("contrato"),
  ); // Teste 81
  const [selectedYear] = useState<any>(query.get("ano"));

  const [linkExterno, setLinkExterno] = useState<any>(true);
  const [nameContrato, setNameContrato] = useState<any>(null);

  const [nameEntidade, setNameEntidade] = useState<any>(null);

  const [select, setSelect] = useState<boolean>(false);
  const [vigenciaContrato, setVigenciaContrato] = useState<any>(null);
  const [vigenciaContratoAtivo, setVigenciaContratoAtivo] = useState<any>(null);
  const [changeSend, setChangeSend] = useState<boolean>(false);
  const [years, setYears] = useState<any>(null);
  const [yearValue, setYearValue] = useState<any>(null);
  const [newObservation, setNewObservation] = useState<any>(null);
  const [documentId, setdocumentId] = useState<any>(null);
  const [file, setFile] = useState<any>(null);
  const [fileBoleto, setFileBoleto] = useState<any>(null);
  const [fileNota, setFileNota] = useState<any>(null);
  const [documents, setDocuments] = useState<Document[]>([]);
  const [pageLoading, setPageLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [pageLoadingEntidades, setPageLoadingEntidades] = useState(true);
  const { user } = useAuth();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
  });

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const yearMoment = moment().year(); //2021

  async function getDocuments(selectedYear: any, contractId: any) {
    setPageLoading(true);
    setVigenciaContrato(null);
    setVigenciaContratoAtivo(null);
    setSelect(true);
    let documentsArray: any[] = [];
    setDocuments([]);

    if (selectedYear) {
      try {
        await api
          .get(`/documentos?contrato=${contractId || selectedContract}`)
          .then(async (res) => {
            const reduced: any[] = [];
            res.data
              .filter((op: any) => op.tipo_documento === 1)
              .forEach((doc: any) => {
                let duplicated =
                  reduced.findIndex((item: any) => {
                    return doc.ano_competencia === item.ano_competencia;
                  }) > -1;
                if (!duplicated) {
                  reduced.push(doc);
                }
              });
            let yearsArray: any[] = [];

            reduced
              .sort(sortYear)
              .map((year: any) => yearsArray.push(year?.ano_competencia));
            setYears(yearsArray);

            const docs = res.data.filter((op: any) => op.tipo_documento === 1);

            if (docs.length > 0) {
              if (yearMoment === parseInt(selectedYear)) {
                if (
                  reduced.find(
                    (doc: any) =>
                      doc.ano_competencia === parseInt(selectedYear),
                  ) !== undefined
                ) {
                  setYearValue(yearMoment);
                  docs.map(
                    (document: any) =>
                      document.ano_competencia === yearMoment &&
                      documentsArray.push(document),
                  );
                } else {
                  if (
                    docs.find(
                      (doc: any) =>
                        doc.ano_competencia === parseInt(selectedYear),
                    ) === undefined
                  ) {
                    docs.filter(
                      (document: any) =>
                        document.ano_competencia ===
                          parseInt(docs.sort(sortYear)[0].ano_competencia) &&
                        documentsArray.push(document),
                    );
                  } else {
                    docs.map(
                      (document: any) =>
                        document.ano_competencia !== yearMoment &&
                        documentsArray.push(document),
                    );
                  }
                }
              } else {
                docs.map(
                  (document: any) =>
                    document.ano_competencia === parseInt(selectedYear) &&
                    documentsArray.push(document),
                );
              }

              setDocuments(documentsArray.sort(sortMesCompetencia));
            } else {
              const contratoVigente = contratos.find(
                (contrato: { id: any }) =>
                  contrato.id === (contractId || selectedContract),
              );

              const fl_libera =
                contratoVigente?.fl_libera_valid_extbolnot_mes_anterior;

              const dataVigente = moment(
                `${contratoVigente?.ano_ini_vigenc_ext_bol_not}-${contratoVigente?.mes_ini_vigenc_ext_bol_not}`,
              );

              setVigenciaContratoAtivo(contratoVigente?.fl_ativo);

              setVigenciaContrato(
                fl_libera
                  ? moment(dataVigente).subtract(1, "month").format("MM/YYYY")
                  : dataVigente.format("MM/YYYY"),
              );
            }
          });
      } catch (err) {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar os documentos",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    } else {
      setDocuments([]);
    }
    setPageLoading(false);
  }

  const sendRelease = async (fl_limite: any) => {
    Swal.fire({
      title: fl_limite
        ? "Essa alteração irá bloquear a validação da competência após a data limite de validação, deseja continuar?"
        : "Essa alteração irá liberar a validação da competência após a data limite de validação, deseja continuar?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsSending(true);

        const documentData = {
          fl_envia_pos_limite: fl_limite ? false : true,
        };

        await api
          .put(`/documentos/${documentId}`, documentData)
          .then(async (res) => {
            const arrayDoc = documents.filter((doc) => doc.id !== documentId);
            setDocuments(
              [
                ...arrayDoc,
                {
                  ...res.data[0],
                },
              ].sort(sortMesCompetencia),
            );

            onClose();
            Swal.fire({
              position: "center",
              icon: "success",
              title: fl_limite
                ? "Arquivo bloqueado para validação"
                : "Arquivo liberado para validação",
              showConfirmButton: false,
              timer: 3000,
            }).then(() => {
              setClick(null);
              setdocumentId(null);
              setObservacao(null);
              setChangeSend(false);
            });
          })
          .catch((error) => {
            console.log("erro: ", error);
            Swal.fire({
              icon: "warning",
              title:
                "Erro ao liberar envio! Tente novamente ou entre em contato com o administrador do sistema",
              showConfirmButton: true,
              confirmButtonText: `Ok`,
            });
          });

        setIsSending(false);
      }
    });
  };

  const sendFile = async (values: any) => {
    Swal.fire({
      title: "Deseja enviar?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsSending(true);
        const dataForm = new FormData();

        dataForm.append(
          "files",
          file,
          `fatura_${observacao.mes_competencia}${
            observacao.ano_competencia
          }_${selectedContract}.${file.type.split("/")[1]}`,
        );

        await api
          .post("/upload", dataForm)
          .then(async (res) => {
            const documentData = {
              valor: parseFloat(valor.replace(".", "").replace(",", ".")),
              id_arquivo: res.data[0].id,
              nome_arquivo: res.data[0].name,
              hash_arquivo: res.data[0].hash + res.data[0].ext,
              status_documento: 2,
            };

            await api
              .put(`/documentos/${documentId}`, documentData)
              .then(async (res) => {
                const newDocument = res.data[0];
                const historyData = {
                  documento: res.data[0].id,
                  users_permissions_user: user?.id,
                  status_documento: 2,
                  valor: res.data[0].valor,
                  observacao: values.observacao,
                  dt_vencimento: res.data[0].dt_vencimento,
                  id_arquivo: res.data[0].id_arquivo,
                  nome_arquivo: res.data[0]?.nome_arquivo,
                  hash_arquivo: res.data[0].hash_arquivo,
                };

                const templateParams = {
                  link: `${baseUrlLink}portal/pessoas-juridicas/cobranca?pj=${res.data[0].entidade.id}&contrato=${res.data[0].contrato.id}&ano=${res.data[0].ano_competencia}`,
                  emailEmpresa: emailsUsers,
                  assunto: "FATURA DISPONÍVEL PARA VALIDAÇÃO",
                  conteudo: `Olá ${nameEntidade}, a fatura de ${
                    observacao.mes_competencia
                  }/${observacao.ano_competencia} com vencimento em ${moment(
                    res.data[0].dt_vencimento,
                  ).format(
                    "DD/MM/YYYY",
                  )} já esta disponível para validação, lembre-se que a data limite para validação é em ${moment(
                    `${res.data[0].ano_competencia}-${res.data[0].mes_competencia}-${res.data[0].contrato.dia_limite_ext_bol_not}`,
                  ).format(
                    "DD/MM/YYYY",
                  )}. Favor verificar e validar assim que possível.`,
                };

                try {
                  await emailjs
                    .send(
                      // @ts-ignore
                      process.env.REACT_APP_SERVICE_ID,
                      process.env.REACT_APP_TEMPLATE_ID_NOTIFICACAO_PJ,
                      templateParams,
                      process.env.REACT_APP_USER_ID,
                    )
                    .then((res) => {
                      console.log("EmailJS Ok!");
                    });
                } catch (e) {
                  console.log(e);
                }

                await api
                  .post("/hist-validacao-docs", historyData)
                  .then((res) => {
                    const arrayDoc = documents.filter(
                      (doc) => doc.id !== documentId,
                    );
                    setDocuments(
                      [
                        ...arrayDoc,
                        {
                          ...newDocument,
                          hist_validacao_docs: [res.data],
                        },
                      ].sort(sortMesCompetencia),
                    );

                    Swal.fire({
                      position: "center",
                      icon: "success",
                      title: "Arquivo enviado com sucesso",
                      showConfirmButton: false,
                      timer: 3000,
                    }).then(() => {
                      onClose();
                    });
                  })
                  .catch((error) => {
                    console.log("erro: ", error);
                    Swal.fire({
                      icon: "warning",
                      title:
                        "Erro ao cadastrar o histórico do documento! Entre em contato com o administrador do sistema",
                      showConfirmButton: true,
                      confirmButtonText: `Ok`,
                    });
                  });
              })
              .catch((error) => {
                console.log("erro: ", error);
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro ao cadastrar o documento! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
            reset(defaultValues);
            setClick(null);
            setdocumentId(null);
            setFile(null);
            setNewFile(false);
            setNewFileComp(false);
            setValor(null);
          })
          .catch((error) => {
            console.log("erro: ", error);
            Swal.fire({
              icon: "warning",
              title:
                "Erro ao enviar a arquivo de extrato! Entre em contato com o administrador do sistema",
              showConfirmButton: true,
              confirmButtonText: `Ok`,
            });
          });
        setIsSending(false);
      }
      setIsSending(false);
    });
  };

  const sendFileBoletoNota = async () => {
    Swal.fire({
      title: "Deseja enviar boleto e nota?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsSending(true);
        const dataFormBoleto = new FormData();
        const dataFormNota = new FormData();

        dataFormBoleto.append(
          "files",
          fileBoleto,
          `boleto_${observacao.mes_competencia}${
            observacao.ano_competencia
          }_${selectedContract}.${fileBoleto.type.split("/")[1]}`,
        );

        dataFormNota.append(
          "files",
          fileNota,
          `nota_${observacao.mes_competencia}${
            observacao.ano_competencia
          }_${selectedContract}.${fileNota.type.split("/")[1]}`,
        );

        await api
          .post("/upload", dataFormBoleto)
          .then(async (res) => {
            const id_arq_boleto = res.data[0].id;
            const nm_arq_boleto = res.data[0].name;
            const hash_arq_boleto = res.data[0].hash + res.data[0].ext;

            await api
              .post("/upload", dataFormNota)
              .then(async (res) => {
                const documentData = {
                  status_documento: 5,
                  id_arq_boleto,
                  nm_arq_boleto,
                  hash_arq_boleto,
                  id_arq_nota: res.data[0].id,
                  nm_arq_nota: res.data[0].name,
                  hash_arq_nota: res.data[0].hash + res.data[0].ext,
                };

                await api
                  .put(`/documentos/${documentId}`, documentData)
                  .then(async (res) => {
                    const newDocument = res.data[0];
                    const historyData = {
                      documento: res.data[0].id,
                      users_permissions_user: user?.id,
                      status_documento: 5,
                      valor: res.data[0].valor,
                      dt_vencimento: res.data[0].dt_vencimento,
                      id_arquivo: res.data[0].id_arquivo,
                      nome_arquivo: res.data[0]?.nome_arquivo,
                      hash_arquivo: res.data[0].hash_arquivo,
                      id_arq_boleto: res.data[0].id_arq_boleto,
                      nm_arq_boleto: res.data[0].nm_arq_boleto,
                      hash_arq_boleto: res.data[0].hash_arq_boleto,
                      id_arq_nota: res.data[0].id_arq_nota,
                      nm_arq_nota: res.data[0].nm_arq_nota,
                      hash_arq_nota: res.data[0].hash_arq_nota,
                    };

                    // const formBoleto = new FormData();
                    // const formNota = new FormData();

                    // formBoleto.append("boleto", fileBoleto);
                    // formNota.append("nota", fileNota);

                    const templateParams = {
                      link: `${baseUrlLink}portal/pessoas-juridicas/cobranca?pj=${res.data[0].entidade.id}&contrato=${res.data[0].contrato.id}&ano=${res.data[0].ano_competencia}`,
                      emailEmpresa: emailsUsers,
                      assunto: "BOLETO E NOTA DISPONÍVEIS PARA PAGAMENTO",
                      conteudo: `Olá ${nameEntidade}, o boleto e nota da competência de ${observacao.mes_competencia}/${observacao.ano_competencia} já estão disponíveis para download e pagamento.`,
                    };

                    try {
                      await emailjs
                        .send(
                          // @ts-ignore
                          process.env.REACT_APP_SERVICE_ID,
                          process.env.REACT_APP_TEMPLATE_ID_NOTIFICACAO_PJ,
                          templateParams,
                          process.env.REACT_APP_USER_ID,
                        )
                        .then((res) => {
                          console.log("EmailJS Ok!");
                        });
                    } catch (e) {
                      console.log(e);
                    }

                    await api
                      .post("/hist-validacao-docs", historyData)
                      .then((res) => {
                        const arrayDoc = documents.filter(
                          (doc) => doc.id !== documentId,
                        );

                        setDocuments(
                          [
                            ...arrayDoc,
                            {
                              ...newDocument,
                              hist_validacao_docs: [
                                ...newDocument.hist_validacao_docs,
                                res.data,
                              ],
                            },
                          ].sort(sortMesCompetencia),
                        );

                        Swal.fire({
                          position: "center",
                          icon: "success",
                          title: "Boleto e nota enviados com sucesso",
                          showConfirmButton: false,
                          timer: 3000,
                        }).then(() => {
                          onClose();
                        });
                      })
                      .catch((error) => {
                        console.log("erro: ", error);
                        Swal.fire({
                          icon: "warning",
                          title:
                            "Erro ao cadastrar o histórico do arquivo! Entre em contato com o administrador do sistema",
                          showConfirmButton: true,
                          confirmButtonText: `Ok`,
                        });
                      });
                  })
                  .catch((error) => {
                    console.log("erro: ", error);
                    Swal.fire({
                      icon: "warning",
                      title:
                        "Erro ao atualizar competência! Entre em contato com o administrador do sistema",
                      showConfirmButton: true,
                      confirmButtonText: `Ok`,
                    });
                  });
                reset(defaultValues);
                setClick(null);
                setdocumentId(null);
                setFileNota(null);
                setFileBoleto(null);
                setisEditing(false);
                setNewFile(false);
                setNewFileComp(false);
                setValor(null);
              })
              .catch((error) => {
                console.log("erro: ", error);
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro ao enviar a arquivo de nota! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          })
          .catch((error) => {
            console.log("erro: ", error);
            Swal.fire({
              icon: "warning",
              title:
                "Erro ao enviar a arquivo de boleto! Entre em contato com o administrador do sistema",
              showConfirmButton: true,
              confirmButtonText: `Ok`,
            });
          });
        setIsSending(false);
      }
      setIsSending(false);
    });
  };

  const sendStatus = async () => {
    Swal.fire({
      title: "O status será alterado, deseja continuar?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsSending(true);

        let id_arq_comprob;
        let nm_arq_comprob;
        let hash_arq_comprob;

        if (newFileComp && inputFileComp !== null) {
          const dataForm = new FormData();

          dataForm.append(
            "files",
            inputFileComp,
            `comprobatorio_${observacao.mes_competencia}${
              observacao.ano_competencia
            }_${selectedContract}.${inputFileComp.type.split("/")[1]}`,
          );

          await api
            .post("/upload", dataForm)
            .then(async (res) => {
              id_arq_comprob = res.data[0].id;
              nm_arq_comprob = res.data[0].name;
              hash_arq_comprob = res.data[0].hash + res.data[0].ext;
            })
            .catch((error) => {
              console.log("erro: ", error);
              Swal.fire({
                icon: "warning",
                title:
                  "Erro enviar arquivo comprobatório! Entre em contato com o administrador do sistema",
                showConfirmButton: true,
                confirmButtonText: `Ok`,
              });
              return;
            });
        }

        const documentData = {
          status_documento: parseInt(status),
          fl_validando_ext_bol_not: false,
          id_arq_comprob:
            newFileComp && inputFileComp !== null ? id_arq_comprob : null,
          nm_arq_comprob:
            newFileComp && inputFileComp !== null ? nm_arq_comprob : null,
          hash_arq_comprob:
            newFileComp && inputFileComp !== null ? hash_arq_comprob : null,
        };

        await api
          .put(`/documentos/${documentId}`, documentData)
          .then(async (res) => {
            const newDocument = res.data[0];
            const historyData = {
              documento: res.data[0].id,
              users_permissions_user: user?.id,
              status_documento: parseInt(status),
              valor: res.data[0].valor,
              observacao: newObservation,
              dt_vencimento: res.data[0].dt_vencimento,
              id_arquivo: res.data[0].id_arquivo,
              nome_arquivo: res.data[0]?.nome_arquivo,
              hash_arquivo: res.data[0].hash_arquivo,
              id_arq_comprob: res.data[0].id_arq_comprob,
              nm_arq_comprob: res.data[0].nm_arq_comprob,
              hash_arq_comprob: res.data[0].hash_arq_comprob,
            };

            if (observacao.status_documento.id === 8) {
              const templateParams = {
                link: `${baseUrlLink}portal/pessoas-juridicas/cobranca?pj=${res.data[0].entidade.id}&contrato=${res.data[0].contrato.id}&ano=${res.data[0].ano_competencia}`,
                emailEmpresa: emailsUsers,
                assunto: "RETORNO DA VALIDAÇÃO DA FATURA",
                conteudo: `Olá ${nameEntidade}, já analisamos a sua validação da fatura de ${observacao.mes_competencia}/${observacao.ano_competencia}. Favor verificar no portal assim que possível para uma nova validação.`,
              };

              try {
                await emailjs
                  .send(
                    // @ts-ignore
                    process.env.REACT_APP_SERVICE_ID,
                    process.env.REACT_APP_TEMPLATE_ID_NOTIFICACAO_PJ,
                    templateParams,
                    process.env.REACT_APP_USER_ID,
                  )
                  .then((res) => {
                    console.log("EmailJS Ok!");
                  });
              } catch (e) {
                console.log(e);
              }
            }

            await api
              .post("/hist-validacao-docs", historyData)
              .then((res) => {
                const arrayDoc = documents.filter(
                  (doc) => doc.id !== documentId,
                );
                setDocuments(
                  [
                    ...arrayDoc,
                    {
                      ...newDocument,
                      hist_validacao_docs: [
                        ...newDocument.hist_validacao_docs,
                        res.data,
                      ],
                    },
                  ].sort(sortMesCompetencia),
                );

                setClick(null);
                setdocumentId(null);
                setObservacao(null);
                setActiveStep(0);
                setStatus("");
                setNewObservation(null);

                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Confirmado com sucesso",
                  showConfirmButton: false,
                  timer: 3000,
                }).then(() => {
                  onClose();
                });
              })
              .catch((error) => {
                console.log("erro: ", error);
                onClose();
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro ao cadastrar o histórico do arquivo! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          })
          .catch((error) => {
            console.log("erro: ", error);
            onClose();
            Swal.fire({
              icon: "warning",
              title:
                "Erro ao atualizar status! Entre em contato com o administrador do sistema",
              showConfirmButton: true,
              confirmButtonText: `Ok`,
            });
          });

        setIsSending(false);
      }
    });
  };

  const handleEditDocument = async () => {
    Swal.fire({
      title: "Deseja enviar?",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setEditLoading(true);

        let id_arquivo;
        let nome_arquivo;
        let hash_arquivo;

        let id_arq_comprob;
        let nm_arq_comprob;
        let hash_arq_comprob;

        if (newFile && inputFileEdit !== null) {
          const dataForm = new FormData();

          dataForm.append(
            "files",
            inputFileEdit,
            `fatura_${observacao.mes_competencia}${
              observacao.ano_competencia
            }_${selectedContract}.${inputFileEdit.type.split("/")[1]}`,
          );

          await api
            .post("/upload", dataForm)
            .then(async (res) => {
              id_arquivo = res.data[0].id;
              nome_arquivo = res.data[0].name;
              hash_arquivo = res.data[0].hash + res.data[0].ext;
            })
            .catch((error) => {
              console.log("erro: ", error);
              Swal.fire({
                icon: "warning",
                title:
                  "Erro enviar arquivo da fatura! Entre em contato com o administrador do sistema",
                showConfirmButton: true,
                confirmButtonText: `Ok`,
              });
              return;
            });
        }

        if (newFileComp && inputFileComp !== null) {
          const dataForm = new FormData();

          dataForm.append(
            "files",
            inputFileComp,
            `comprobatorio_${observacao.mes_competencia}${
              observacao.ano_competencia
            }_${selectedContract}.${inputFileComp.type.split("/")[1]}`,
          );

          await api
            .post("/upload", dataForm)
            .then(async (res) => {
              id_arq_comprob = res.data[0].id;
              nm_arq_comprob = res.data[0].name;
              hash_arq_comprob = res.data[0].hash + res.data[0].ext;
            })
            .catch((error) => {
              console.log("erro: ", error);
              Swal.fire({
                icon: "warning",
                title:
                  "Erro enviar arquivo comprobatório! Entre em contato com o administrador do sistema",
                showConfirmButton: true,
                confirmButtonText: `Ok`,
              });
              return;
            });
        }

        const documentData = {
          valor: inputValorEdit
            ? parseFloat(inputValorEdit.replace(".", "").replace(",", "."))
            : observacao.valor,
          id_arquivo:
            newFile && inputFileEdit !== null
              ? id_arquivo
              : observacao.id_arquivo,
          nome_arquivo:
            newFile && inputFileEdit !== null
              ? nome_arquivo
              : observacao?.nome_arquivo,
          hash_arquivo:
            newFile && inputFileEdit !== null
              ? hash_arquivo
              : observacao.hash_arquivo,
          id_arq_comprob:
            newFileComp && inputFileComp !== null
              ? id_arq_comprob
              : observacao.id_arq_comprob,
          nm_arq_comprob:
            newFileComp && inputFileComp !== null
              ? nm_arq_comprob
              : observacao.nm_arq_comprob,
          hash_arq_comprob:
            newFileComp && inputFileComp !== null
              ? hash_arq_comprob
              : observacao.hash_arq_comprob,
          status_documento: 2,
          fl_validando_ext_bol_not: false,
        };

        await api
          .put(`/documentos/${documentId}`, documentData)
          .then(async (res) => {
            const newDocument = res.data[0];
            const historyData = {
              documento: res.data[0].id,
              users_permissions_user: user?.id,
              status_documento: 2,
              valor: res.data[0].valor,
              observacao: inputObervacaoEdit,
              dt_vencimento: res.data[0].dt_vencimento,
              id_arquivo: res.data[0].id_arquivo,
              nome_arquivo: res.data[0]?.nome_arquivo,
              hash_arquivo: res.data[0].hash_arquivo,
              id_arq_comprob: res.data[0].id_arq_comprob,
              nm_arq_comprob: res.data[0].nm_arq_comprob,
              hash_arq_comprob: res.data[0].hash_arq_comprob,
            };

            if (observacao.status_documento.id === 3) {
              const templateParams = {
                link: `${baseUrlLink}portal/pessoas-juridicas/cobranca?pj=${res.data[0].entidade.id}&contrato=${res.data[0].contrato.id}&ano=${res.data[0].ano_competencia}`,
                emailEmpresa: emailsUsers,
                assunto: "RETORNO DA VALIDAÇÃO DA FATURA",
                conteudo: `Olá ${nameEntidade}, já analisamos a sua validação da fatura de ${observacao.mes_competencia}/${observacao.ano_competencia}. Favor verificar no portal assim que possível para uma nova validação.`,
              };

              try {
                await emailjs
                  .send(
                    // @ts-ignore
                    process.env.REACT_APP_SERVICE_ID,
                    process.env.REACT_APP_TEMPLATE_ID_NOTIFICACAO_PJ,
                    templateParams,
                    process.env.REACT_APP_USER_ID,
                  )
                  .then((res) => {
                    console.log("EmailJS Ok!");
                  });
              } catch (e) {
                console.log(e);
              }
            }

            await api
              .post("/hist-validacao-docs", historyData)
              .then((res) => {
                const arrayDoc = documents.filter(
                  (doc) => doc.id !== documentId,
                );
                setDocuments(
                  [
                    ...arrayDoc,
                    {
                      ...newDocument,
                      hist_validacao_docs: [
                        ...newDocument.hist_validacao_docs,
                        res.data,
                      ],
                    },
                  ].sort(sortMesCompetencia),
                );
                setClick(null);
                setisEditing(false);
                setNewFile(false);
                setNewFileComp(false);
                setdocumentId(null);
                setInputFileEdit(null);
                setInputFileComp(null);
                setInputObservacaoEdit("");
                setInputValorEdit(null);
                setEditLoading(false);
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Enviado com sucesso",
                  showConfirmButton: false,
                  timer: 3000,
                }).then(() => {
                  onClose();
                });
              })
              .catch((error) => {
                console.log("erro: ", error);
                Swal.fire({
                  icon: "warning",
                  title:
                    "Erro ao cadastrar o histórico! Entre em contato com o administrador do sistema",
                  showConfirmButton: true,
                  confirmButtonText: `Ok`,
                });
              });
          })
          .catch((error) => {
            console.log("erro: ", error);
            setEditLoading(false);
            Swal.fire({
              icon: "warning",
              title:
                "Erro ao cadastrar o arquivo! Entre em contato com o administrador do sistema",
              showConfirmButton: true,
              confirmButtonText: `Ok`,
            });
          });
      }
    });
    setEditLoading(false);
  };

  useEffect(() => {
    async function getEntidades() {
      try {
        const response = await api.get("/entidades?_sort=id:DESC");
        const entidadesWithContracts = response.data.filter(
          (ent: any) =>
            ent.contratoes.find(
              (cont: any) =>
                (cont.fl_extrato_boleto_nota &&
                  cont.fl_resp_pelo_pagamento === "P") ||
                (cont.fl_extrato_boleto_nota &&
                  cont.fl_resp_pelo_pagamento === null),
            ) ||
            ent.contrato_vinculado.find(
              (cont: any) =>
                cont.fl_extrato_boleto_nota &&
                cont.fl_resp_pelo_pagamento === "E",
            ),
        );

        if (
          selectedEntidade &&
          selectedContract &&
          selectedYear &&
          linkExterno
        ) {
          const ent = response.data.filter(
            (ent: any) => ent.id === parseInt(selectedEntidade),
          );

          setStatusContract("ativo");
          setNameEntidade(ent[0]?.nm_entidade);
          setDocuments([]);

          let arrayContracts: any[] = [];

          ent[0]?.contratoes.map(
            (doc: any) =>
              ((doc.fl_extrato_boleto_nota &&
                doc.fl_resp_pelo_pagamento === "P") ||
                (doc.fl_extrato_boleto_nota &&
                  doc.fl_resp_pelo_pagamento === null)) &&
              arrayContracts.push(doc),
          );
          ent[0]?.contrato_vinculado.map(
            (doc: any) =>
              doc.fl_extrato_boleto_nota &&
              doc.fl_resp_pelo_pagamento === "E" &&
              arrayContracts.push(doc),
          );

          setContratos(arrayContracts);
          setNameContrato(
            ent[0].contratoes
              .filter(
                (ent: any) =>
                  (ent.fl_extrato_boleto_nota &&
                    ent.fl_resp_pelo_pagamento === "P") ||
                  (ent.fl_extrato_boleto_nota &&
                    ent.fl_resp_pelo_pagamento === null),
              )
              .filter(
                (cont: any) => parseInt(cont.id) === parseInt(selectedContract),
              )[0]?.desc_contrato ||
              ent[0].contrato_vinculado
                .filter(
                  (ent: any) =>
                    ent.fl_extrato_boleto_nota &&
                    ent.fl_resp_pelo_pagamento === "E",
                )
                .filter(
                  (cont: any) =>
                    parseInt(cont.id) === parseInt(selectedContract),
                )[0]?.desc_contrato,
          );

          getDocuments(selectedYear, selectedContract);
          setLinkExterno(false);
        }
        setPessoasJuridicas(entidadesWithContracts);
        setPageLoadingEntidades(false);
      } catch (err) {
        console.log(err);
        setPageLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro ao listar as Pessoas Jurídicas",
          showConfirmButton: true,
          confirmButtonText: `Ok`,
        });
      }
    }

    async function getUsuariosContratos() {
      try {
        const response = await api.get("/usuarios-contratoes?_limit=-1");
        setUsuariosContratos(response.data);
        if (selectedContract !== null) {
          setEmailsUsers(
            response.data
              .filter((user: any) =>
                user.contratoes.find(
                  (cont: any) => cont.id === parseInt(selectedContract),
                ),
              )
              .map((user: any) => user.users_permissions_user?.email)
              .join(", "),
          );
        }
      } catch (err) {
        console.log(err);
        setPageLoading(false);
        // Swal.fire({
        //   icon: "error",
        //   title: "Erro ao buscar as Pessoas Jurídicas",
        //   showConfirmButton: true,
        //   confirmButtonText: `Ok`,
        // });
      }
    }

    getEntidades();
    getUsuariosContratos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEntidade]);

  const getContracts = (idOperator: any) => {
    setSelectedContract(null);
    setDocuments([]);
    const ent = pessoasJuridicas.filter(
      (ent) => ent.id === parseInt(idOperator),
    );

    let arrayContracts: any[] = [];

    ent[0]?.contratoes.map(
      (doc: any) =>
        ((doc.fl_extrato_boleto_nota && doc.fl_resp_pelo_pagamento === "P") ||
          (doc.fl_extrato_boleto_nota &&
            doc.fl_resp_pelo_pagamento === null)) &&
        arrayContracts.push(doc),
    );
    ent[0]?.contrato_vinculado.map(
      (doc: any) =>
        doc.fl_extrato_boleto_nota &&
        doc.fl_resp_pelo_pagamento === "E" &&
        arrayContracts.push(doc),
    );

    setContratos(arrayContracts);
  };

  const handleChangeSelectedEntidade = (selectedOption: any) => {
    setContractValue(null);
    getContracts(selectedOption.value);
    setSelectedEntidade(selectedOption.value);
    setStatusContract("ativo");
    setNameEntidade(selectedOption.label);
  };

  const handleChangeSelectedContract = (selectedOption: any) => {
    setContractValue(selectedOption.value);
    getDocuments(yearMoment, selectedOption.value);
    setSelectedContract(selectedOption.value);
    setEmailsUsers(
      usuariosContratos
        .filter((user) =>
          user.contratoes.find((cont: any) => cont.id === selectedOption.value),
        )
        .map((user) => user.users_permissions_user?.email)
        .join(", "),
    );
  };

  if (pageLoadingEntidades) {
    return (
      <Box
        as="section"
        display="flex"
        w="100%"
        justifyContent="center"
        alignItems="center"
      >
        <CircularProgress isIndeterminate color="blue.200" />
      </Box>
    );
  }

  return (
    contratos && (
      <>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          overflow="hidden"
          h={notebook ? "calc(100vh + 40px)" : "unset"}
          margin="30px"
          gridRowGap="15px"
          position="relative"
        >
          <Box
            display="flex"
            flexDirection={mobile ? "column" : "row"}
            gridGap="15px"
            width="100%"
            height="max-content"
            maxWidth="500px"
            padding="12px"
            backgroundColor="#fff"
            boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
          >
            {pessoasJuridicas.length > 0 ? (
              <FormControl>
                <FormLabel htmlFor="selectedEntidade">
                  Pessoa jurídica:
                </FormLabel>
                <ReactSelect
                  className="basic-single"
                  classNamePrefix="select"
                  closeMenuOnSelect={true}
                  isSearchable={true}
                  placeholder="Selecione uma pessoa jurídica"
                  noOptionsMessage={() => "-"}
                  onChange={handleChangeSelectedEntidade}
                  defaultValue={
                    selectedEntidade && {
                      value: selectedEntidade,
                      label: nameEntidade,
                    }
                  }
                  options={pessoasJuridicas.map((ent) => ({
                    value: ent.id,
                    label: ent.nm_entidade,
                  }))}
                  components={animatedComponents}
                />
              </FormControl>
            ) : (
              <Alert status="info">
                <AlertIcon />
                Nenhum dado cadastrado!
              </Alert>
            )}
          </Box>
          {contratos && selectedEntidade && (
            <>
              {contratos &&
                contratos.filter((doc: any) => !doc.fl_ativo).length > 0 && (
                  <Box
                    display="flex"
                    flexDirection={mobile ? "column" : "row"}
                    gridGap="15px"
                    width="100%"
                    height="max-content"
                    maxWidth="500px"
                    padding="12px"
                    backgroundColor="#fff"
                    boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
                  >
                    <FormControl>
                      <FormLabel htmlFor="ano">Status dos contratos:</FormLabel>
                      <Select
                        id="statusContrato"
                        name="statusContrato"
                        type="text"
                        onChange={(e: any) => {
                          setStatusContract(e.target.value);
                          setDocuments([]);
                          setSelect(false);
                        }}
                        value={statusContract}
                      >
                        <option key="1" value="ativo">
                          Ativos
                        </option>
                        <option key="2" value="inativo">
                          Inativos
                        </option>
                      </Select>
                    </FormControl>
                  </Box>
                )}
              <Box
                display="flex"
                flexDirection={mobile ? "column" : "row"}
                gridGap="15px"
                width="100%"
                height="max-content"
                maxWidth="500px"
                padding="12px"
                backgroundColor="#fff"
                boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
    0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
              >
                <FormControl>
                  <FormLabel htmlFor="contratos">
                    Contratos{" "}
                    {statusContract === "ativo" ? "ativos" : "inativos"}:
                  </FormLabel>
                  <ReactSelect
                    className="basic-single"
                    classNamePrefix="select"
                    closeMenuOnSelect={true}
                    isSearchable={true}
                    placeholder="Selecione um contrato"
                    noOptionsMessage={() => "-"}
                    onChange={handleChangeSelectedContract}
                    value={
                      selectedContract && {
                        contractValue,
                        label:
                          (contratos &&
                            contratos.find(
                              (el: any) => el.id === parseInt(contractValue),
                            )?.desc_contrato) ||
                          nameContrato,
                      }
                    }
                    defaultValue={
                      selectedContract && {
                        value: selectedContract,
                        label: nameContrato,
                      }
                    }
                    options={contratos
                      .filter((doc: any) =>
                        statusContract === "ativo"
                          ? doc.fl_ativo
                          : !doc.fl_ativo,
                      )
                      .map((contrato: { id: any; desc_contrato: any }) => ({
                        value: contrato.id,
                        label: contrato.desc_contrato,
                      }))}
                    components={animatedComponents}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel htmlFor="ano">Ano:</FormLabel>
                  <Select
                    id="ano"
                    name="ano"
                    type="text"
                    onChange={(e: any) => {
                      getDocuments(e.target.value, null);
                      setYearValue(e.target.value);
                    }}
                    value={yearValue}
                  >
                    {years &&
                      years.map((year: any) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                  </Select>
                </FormControl>
              </Box>
              {selectedContract && (
                <Button
                  position="absolute"
                  right="10px"
                  top={
                    contratos &&
                    contratos.filter((doc: any) => !doc.fl_ativo).length > 0
                      ? mobile
                        ? "410px"
                        : "275px"
                      : mobile
                      ? "300px"
                      : "175px"
                  }
                  margin="0 auto"
                  colorScheme="unset"
                  variant="solid"
                  padding="0"
                  color="#555"
                  cursor="pointer"
                  _hover={{
                    backgroundColor: "#e3e8f0",
                    color: "blue.600",
                  }}
                  onClick={() => getDocuments(yearMoment, selectedContract)}
                >
                  {pageLoading ? (
                    <CircularProgress
                      isIndeterminate
                      size="22"
                      color="blue.200"
                    />
                  ) : (
                    <AiOutlineReload size="25" />
                  )}
                </Button>
              )}
              {selectedContract && documents.length > 0 ? (
                <>
                  {pageLoading ? (
                    <Box
                      as="section"
                      display="flex"
                      w="100%"
                      height="300px"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <CircularProgress isIndeterminate color="blue.200" />
                    </Box>
                  ) : (
                    <>
                      <Box
                        display="flex"
                        marginTop={mobile ? "40px" : 0}
                        flexDirection="column"
                        overflow="auto"
                        width="100%"
                        height="max-content"
                        padding="15px"
                        backgroundColor="#fff"
                        boxShadow="0px 3px 3px -2px rgb(0 0 0 / 20%),
            0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%)"
                      >
                        <Box
                          fontSize="17px"
                          display="grid"
                          gridTemplateColumns="110px 240px 100px 96px 70px 50px 95px 77px 108px"
                          justifyContent="space-between"
                          padding="0 5px"
                          minWidth="960px"
                          alignItems="center"
                        >
                          <Text paddingLeft="5px">Competência</Text>
                          <Text>Status</Text>
                          <Text textAlign="center">Enviar/Editar</Text>
                          <Text textAlign="center">Modificação</Text>
                          <Text>Valor</Text>
                          <Text textAlign="center">Fatura</Text>
                          <Text textAlign="center">Vencimento</Text>
                          <Text textAlign="center">Histórico</Text>
                          <Text textAlign="center">Boleto e nota</Text>
                        </Box>
                        <Accordion allowToggle>
                          {documents &&
                            documents.length > 0 &&
                            documents.map((doc, i) => (
                              <AccordionItem
                                key={i}
                                border="none"
                                margin="5px 0"
                                minWidth="960px"
                                backgroundColor="#eee"
                                borderRadius="12px"
                                _hover={{ backgroundColor: "#e3e8f0" }}
                              >
                                <Box
                                  fontSize="16px"
                                  display="grid"
                                  gridTemplateColumns="110px 240px 100px 96px 70px 50px 95px 77px 108px"
                                  minWidth="960px"
                                  justifyContent="space-between"
                                  padding="5px"
                                  alignItems="center"
                                >
                                  <Text paddingLeft="5px" fontSize="17px">
                                    {meses[doc.mes_competencia - 1]}
                                  </Text>
                                  <Alert
                                    padding="5px"
                                    backgroundColor="unset"
                                    status={
                                      (doc?.status_documento === 2 ||
                                        doc?.status_documento?.id === 2) &&
                                      moment().format("YYYY/MM/DD") <=
                                        moment(
                                          `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                        ).format("YYYY/MM/DD")
                                        ? "info"
                                        : doc?.status_documento === 5 ||
                                          doc?.status_documento?.id === 5
                                        ? doc.fl_pendencia_ext_bol_not
                                          ? "info"
                                          : "success"
                                        : doc?.status_documento === 3 ||
                                          doc?.status_documento?.id === 3
                                        ? "error"
                                        : doc?.status_documento === 4 ||
                                          doc?.status_documento?.id === 4
                                        ? "success"
                                        : "warning"
                                    }
                                  >
                                    <AlertIcon />

                                    <Text>
                                      {doc?.status_documento === 1 ||
                                      doc?.status_documento?.id === 1 ? (
                                        <>
                                          Não enviado. Data limite para
                                          validação:{" "}
                                          <b>
                                            {moment(
                                              `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                            ).format("DD/MM/YYYY")}
                                          </b>
                                        </>
                                      ) : doc?.status_documento === 2 ||
                                        doc?.status_documento?.id === 2 ? (
                                        moment().format("YYYY/MM/DD") >
                                        moment(
                                          `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                        ).format("YYYY/MM/DD") ? (
                                          doc.fl_envia_pos_limite ? (
                                            <>
                                              Não validado até a data limite.{" "}
                                              <b>Liberado para validação</b>
                                            </>
                                          ) : (
                                            <>
                                              Não validado até a data limite.{" "}
                                              <b>Bloqueado para validação</b>
                                            </>
                                          )
                                        ) : doc.fl_validando_ext_bol_not ? (
                                          <>
                                            Enviado. Em validação{" "}
                                            <b>
                                              Limite para validação:{" "}
                                              {moment(
                                                `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                              ).format("DD/MM/YYYY")}
                                            </b>
                                          </>
                                        ) : (
                                          <>
                                            Enviado. Aguarde validação{" "}
                                            <b>
                                              Limite para validação:{" "}
                                              {moment(
                                                `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                              ).format("DD/MM/YYYY")}
                                            </b>
                                          </>
                                        )
                                      ) : doc?.status_documento === 3 ||
                                        doc?.status_documento?.id === 3 ? (
                                        "Negado. Aguardando reenvio"
                                      ) : doc?.status_documento === 4 ||
                                        doc?.status_documento?.id === 4 ? (
                                        "Validado"
                                      ) : doc?.status_documento === 5 ||
                                        doc?.status_documento?.id === 5 ? (
                                        doc.fl_pendencia_ext_bol_not ? (
                                          <>
                                            Boleto e nota disponíveis{" "}
                                            <Text
                                              color="#E53E3E"
                                              fontWeight="500"
                                            >
                                              Validado com pendência
                                            </Text>
                                          </>
                                        ) : (
                                          "Boleto e nota disponíveis"
                                        )
                                      ) : doc?.status_documento === 8 ||
                                        doc?.status_documento?.id === 8 ? (
                                        "Validado com pendência"
                                      ) : (
                                        "Não enviado"
                                      )}
                                    </Text>
                                  </Alert>

                                  <Button
                                    onClick={
                                      (doc?.status_documento === 1 ||
                                        doc?.status_documento?.id === 1) &&
                                      statusContract === "ativo"
                                        ? () => {
                                            onOpen();
                                            setdocumentId(doc.id);
                                            setObservacao(doc);
                                            setClick("enviar");
                                          }
                                        : doc?.status_documento === 3 ||
                                          doc?.status_documento?.id === 3 ||
                                          ((doc?.status_documento === 2 ||
                                            doc?.status_documento?.id === 2) &&
                                            !doc.fl_validando_ext_bol_not &&
                                            moment().format("YYYY/MM/DD") <=
                                              moment(
                                                `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                              ).format("YYYY/MM/DD"))
                                        ? () => {
                                            onOpen();
                                            setEditLoading(false);
                                            setdocumentId(doc.id);
                                            setClick("editar");
                                            setObservacao(doc);
                                          }
                                        : doc?.status_documento === 4 ||
                                          doc?.status_documento?.id === 4 ||
                                          doc?.status_documento === 8 ||
                                          doc?.status_documento?.id === 8
                                        ? () => {
                                            onOpen();
                                            setdocumentId(doc.id);
                                            setClick("editarStatus");
                                            setObservacao(doc);
                                          }
                                        : (doc?.status_documento === 5 ||
                                            doc?.status_documento?.id === 5) &&
                                          doc.fl_validando_ext_bol_not &&
                                          doc.fl_pendencia_ext_bol_not
                                        ? () => {
                                            onOpen();
                                            setdocumentId(doc.id);
                                            setClick("observacaoPendencia");
                                            setObservacao(doc);
                                          }
                                        : (doc?.status_documento === 2 ||
                                            doc?.status_documento?.id === 2) &&
                                          moment().format("YYYY/MM/DD") <=
                                            moment(
                                              `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                            ).format("YYYY/MM/DD")
                                        ? () => {
                                            onOpen();
                                            setClick("enviado");
                                            setObservacao(doc);
                                          }
                                        : (doc?.status_documento === 2 ||
                                            doc?.status_documento?.id === 2) &&
                                          moment().format("YYYY/MM/DD") >
                                            moment(
                                              `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                            ).format("YYYY/MM/DD")
                                        ? () => {
                                            onOpen();
                                            setClick("expirado");
                                            setObservacao(doc);
                                            setdocumentId(doc.id);
                                          }
                                        : () => {}
                                    }
                                    margin="0 auto"
                                    colorScheme="unset"
                                    variant="solid"
                                    padding="0"
                                    color="#555"
                                    cursor={
                                      statusContract === "ativo" &&
                                      (doc?.status_documento === 1 ||
                                        doc?.status_documento?.id === 1 ||
                                        doc?.status_documento === 2 ||
                                        doc?.status_documento?.id === 2 ||
                                        doc?.status_documento === 3 ||
                                        doc?.status_documento?.id === 3 ||
                                        doc?.status_documento === 4 ||
                                        doc?.status_documento?.id === 4 ||
                                        doc?.status_documento === 8 ||
                                        doc?.status_documento?.id === 8 ||
                                        ((doc?.status_documento === 5 ||
                                          doc?.status_documento?.id === 5) &&
                                          doc.fl_validando_ext_bol_not &&
                                          doc.fl_pendencia_ext_bol_not))
                                        ? "pointer"
                                        : "unset"
                                    }
                                    _hover={
                                      statusContract === "ativo" &&
                                      (doc?.status_documento === 1 ||
                                        doc?.status_documento?.id === 1 ||
                                        doc?.status_documento === 2 ||
                                        doc?.status_documento?.id === 2 ||
                                        doc?.status_documento === 3 ||
                                        doc?.status_documento?.id === 3 ||
                                        doc?.status_documento === 4 ||
                                        doc?.status_documento?.id === 4 ||
                                        doc?.status_documento === 8 ||
                                        doc?.status_documento?.id === 8 ||
                                        ((doc?.status_documento === 5 ||
                                          doc?.status_documento?.id === 5) &&
                                          doc.fl_validando_ext_bol_not &&
                                          doc.fl_pendencia_ext_bol_not))
                                        ? {
                                            backgroundColor: "#cad8eb",
                                            color: "blue.600",
                                          }
                                        : {}
                                    }
                                  >
                                    {(doc?.status_documento === 2 ||
                                      doc?.status_documento?.id === 2) &&
                                    moment().format("YYYY/MM/DD") <=
                                      moment(
                                        `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                      ).format("YYYY/MM/DD") ? (
                                      <MdEdit size="20px" color="#1f71a0" />
                                    ) : doc?.status_documento === 3 ||
                                      doc?.status_documento?.id === 3 ? (
                                      <FcHighPriority size="20px" />
                                    ) : doc?.status_documento === 4 ||
                                      doc?.status_documento?.id === 4 ||
                                      doc?.status_documento === 8 ||
                                      doc?.status_documento?.id === 8 ? (
                                      // <FcCheckmark size="20px" />
                                      <MdEdit size="20px" color="#1f71a0" />
                                    ) : statusContract === "ativo" &&
                                      (doc?.status_documento === 1 ||
                                        doc?.status_documento?.id === 1) ? (
                                      <MdFileUpload size="20px" />
                                    ) : statusContract === "ativo" &&
                                      (doc?.status_documento === 5 ||
                                        doc?.status_documento?.id === 5) &&
                                      doc.fl_validando_ext_bol_not &&
                                      doc.fl_pendencia_ext_bol_not ? (
                                      <FcAbout size="25px" />
                                    ) : statusContract === "ativo" &&
                                      (doc?.status_documento === 5 ||
                                        doc?.status_documento?.id === 5) ? (
                                      "-"
                                    ) : statusContract === "ativo" ? (
                                      <FcExpired size="25px" />
                                    ) : (
                                      "-"
                                    )}
                                  </Button>

                                  {doc?.status_documento === 1 ||
                                  doc?.status_documento?.id === 1 ? (
                                    <Text textAlign="center">-</Text>
                                  ) : (
                                    <Text textAlign="center">
                                      {moment(doc.updated_at).format(
                                        "DD/MM/YYYY",
                                      )}
                                    </Text>
                                  )}

                                  {doc?.status_documento === 1 ||
                                  doc?.status_documento?.id === 1 ? (
                                    <Text marginLeft="20px">-</Text>
                                  ) : (
                                    <Text display="flex" gridColumnGap="3px">
                                      <span>R$</span>
                                      <NumberFormat
                                        readOnly
                                        decimalScale={2}
                                        decimalSeparator=","
                                        fixedDecimalScale
                                        thousandSeparator="."
                                        value={doc.valor}
                                        style={{
                                          width: "max-content",
                                          background: "none",
                                        }}
                                      />
                                    </Text>
                                  )}

                                  {doc?.status_documento === 1 ||
                                  doc?.status_documento?.id === 1 ? (
                                    <Text textAlign="center">-</Text>
                                  ) : (
                                    <Text textAlign="center">
                                      <Button
                                        onClick={() =>
                                          download(doc.hash_arquivo)
                                        }
                                        margin="0 auto"
                                        colorScheme="unset"
                                        variant="solid"
                                        padding="0"
                                        color="#555"
                                        cursor="pointer"
                                        _hover={{
                                          backgroundColor: "#cad8eb",
                                          color: "blue.600",
                                        }}
                                      >
                                        <MdFileDownload size="20px" />
                                      </Button>
                                    </Text>
                                  )}

                                  <Text textAlign="center">
                                    {moment(doc.dt_vencimento).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>

                                  <AccordionButton
                                    margin="0 auto"
                                    justifyContent="center"
                                    width="40px"
                                    height="40px"
                                    padding="0"
                                    borderRadius="8px"
                                    _hover={{
                                      backgroundColor: "#cad8eb",
                                      color: "blue.600",
                                    }}
                                  >
                                    <AccordionIcon />
                                  </AccordionButton>

                                  <Text textAlign="center">
                                    <Button
                                      onClick={
                                        doc?.status_documento === 4 ||
                                        doc?.status_documento?.id === 4 ||
                                        doc?.status_documento === 8 ||
                                        doc?.status_documento?.id === 8 ||
                                        ((doc?.status_documento === 2 ||
                                          doc?.status_documento?.id === 2) &&
                                          moment().format("YYYY/MM/DD") >
                                            moment(
                                              `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                            ).format("YYYY/MM/DD"))
                                          ? () => {
                                              onOpen();
                                              setEditLoading(false);
                                              setdocumentId(doc.id);
                                              setClick("uploadBoleto");
                                              setObservacao(doc);
                                            }
                                          : doc?.status_documento === 5 ||
                                            doc?.status_documento?.id === 5
                                          ? () => {
                                              onOpen();
                                              setEditLoading(false);
                                              setdocumentId(doc.id);
                                              setClick("editBoleto");
                                              setObservacao(doc);
                                            }
                                          : () => {}
                                      }
                                      margin="0 auto"
                                      colorScheme="unset"
                                      variant="solid"
                                      padding="0"
                                      color="#555"
                                      cursor={
                                        doc?.status_documento === 4 ||
                                        doc?.status_documento?.id === 4 ||
                                        doc?.status_documento === 5 ||
                                        doc?.status_documento?.id === 5 ||
                                        doc?.status_documento === 8 ||
                                        doc?.status_documento?.id === 8 ||
                                        ((doc?.status_documento === 2 ||
                                          doc?.status_documento?.id === 2) &&
                                          moment().format("YYYY/MM/DD") >
                                            moment(
                                              `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                            ).format("YYYY/MM/DD"))
                                          ? "pointer"
                                          : "unset"
                                      }
                                      _hover={
                                        doc?.status_documento === 4 ||
                                        doc?.status_documento?.id === 4 ||
                                        doc?.status_documento === 5 ||
                                        doc?.status_documento?.id === 5 ||
                                        doc?.status_documento === 8 ||
                                        doc?.status_documento?.id === 8 ||
                                        ((doc?.status_documento === 2 ||
                                          doc?.status_documento?.id === 2) &&
                                          moment().format("YYYY/MM/DD") >
                                            moment(
                                              `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                            ).format("YYYY/MM/DD"))
                                          ? {
                                              backgroundColor: "#cad8eb",
                                              color: "blue.600",
                                            }
                                          : {}
                                      }
                                    >
                                      {doc?.status_documento === 4 ||
                                      doc?.status_documento?.id === 4 ||
                                      doc?.status_documento === 8 ||
                                      doc?.status_documento?.id === 8 ||
                                      ((doc?.status_documento === 2 ||
                                        doc?.status_documento?.id === 2) &&
                                        moment().format("YYYY/MM/DD") >
                                          moment(
                                            `${doc.ano_competencia}-${doc.mes_competencia}-${doc.contrato.dia_limite_ext_bol_not}`,
                                          ).format("YYYY/MM/DD")) ? (
                                        <RiFileTextLine
                                          size="23px"
                                          color="#2160b8"
                                        />
                                      ) : doc?.status_documento === 5 ||
                                        doc?.status_documento?.id === 5 ? (
                                        <RiFileEditFill
                                          size="23px"
                                          color="#2160b8"
                                        />
                                      ) : (
                                        "-"
                                      )}
                                    </Button>
                                  </Text>
                                </Box>
                                <AccordionPanel
                                  padding="20px"
                                  borderTop="1px solid white"
                                >
                                  <Box display="flex">
                                    {doc?.hist_validacao_docs?.length > 0 ? (
                                      <>
                                        <Box
                                          width="100%"
                                          borderRadius="12px"
                                          margin="2px 0"
                                          padding="5px"
                                          height="max-content"
                                        >
                                          <Text
                                            width="max-content"
                                            margin="5px"
                                            fontSize="18px"
                                            fontWeight="500"
                                          >
                                            Histórico
                                          </Text>
                                          <Box
                                            fontSize="16px"
                                            display="grid"
                                            gridTemplateColumns="15% 11% 11% 11% 8% 14% 8% 11% 11%"
                                            width="100%"
                                            padding="5px"
                                            alignItems="center"
                                          >
                                            <Text>Status</Text>
                                            <Text textAlign="center">
                                              Usuário
                                            </Text>
                                            <Text textAlign="center">
                                              Modificação
                                            </Text>
                                            <Text textAlign="center">Hora</Text>
                                            <Text textAlign="center">
                                              Fatura
                                            </Text>
                                            <Text textAlign="center">
                                              Comprobatórios
                                            </Text>
                                            <Text marginLeft="10px">Valor</Text>
                                            <Text textAlign="center">
                                              Observação
                                            </Text>
                                            <Text textAlign="center">
                                              Boleto e nota
                                            </Text>
                                          </Box>
                                          {doc.hist_validacao_docs
                                            .sort(sortDESC)
                                            .map((hist: any) => (
                                              <Box
                                                key={hist.id}
                                                borderTop="1px solid white"
                                                fontSize="16px"
                                                display="grid"
                                                gridTemplateColumns="15% 11% 11% 11% 8% 14% 8% 11% 11%"
                                                width="100%"
                                                padding="5px"
                                                alignItems="center"
                                                // _hover={{
                                                //   backgroundColor: "#d5e1ea",
                                                // }}
                                              >
                                                <Alert
                                                  padding="5px"
                                                  backgroundColor="unset"
                                                  status={
                                                    hist?.status_documento
                                                      ?.id === 2 ||
                                                    hist?.status_documento === 2
                                                      ? "info"
                                                      : hist?.status_documento
                                                          ?.id === 3 ||
                                                        hist?.status_documento ===
                                                          3
                                                      ? "error"
                                                      : hist?.status_documento
                                                          ?.id === 4 ||
                                                        hist?.status_documento ===
                                                          4 ||
                                                        hist?.status_documento
                                                          ?.id === 5 ||
                                                        hist?.status_documento ===
                                                          5
                                                      ? "success"
                                                      : "warning"
                                                  }
                                                >
                                                  <AlertIcon />
                                                  {hist?.status_documento
                                                    ?.id === 2 ||
                                                  hist?.status_documento === 2
                                                    ? "Enviado. Aguardando validação"
                                                    : hist?.status_documento
                                                        ?.id === 3 ||
                                                      hist?.status_documento ===
                                                        3
                                                    ? "Negado. Aguardando reenvio"
                                                    : hist?.status_documento
                                                        ?.id === 4 ||
                                                      hist?.status_documento ===
                                                        4
                                                    ? "Validado"
                                                    : hist?.status_documento
                                                        ?.id === 5 ||
                                                      hist?.status_documento ===
                                                        5
                                                    ? "Boleto e nota disponíveis"
                                                    : hist?.status_documento
                                                        ?.id === 8 ||
                                                      hist?.status_documento ===
                                                        8
                                                    ? "Validado com pendência"
                                                    : "Não enviado"}
                                                </Alert>
                                                <Text
                                                  textAlign="center"
                                                  fontSize="15px"
                                                >
                                                  {
                                                    hist.users_permissions_user
                                                      ?.nome
                                                  }
                                                </Text>
                                                <Text textAlign="center">
                                                  {moment(
                                                    hist.published_at,
                                                  ).format("DD/MM/YYYY")}
                                                </Text>
                                                <Text textAlign="center">
                                                  {moment(
                                                    hist.published_at,
                                                  ).format("HH:mm")}
                                                </Text>

                                                {hist.id_arquivo ? (
                                                  <Text textAlign="center">
                                                    <Button
                                                      onClick={() => {
                                                        // onOpen();
                                                        download(
                                                          hist.hash_arquivo,
                                                        );
                                                      }}
                                                      colorScheme="unset"
                                                      variant="solid"
                                                      padding="0"
                                                      color="#555"
                                                      _hover={{
                                                        backgroundColor:
                                                          "#cad8eb",
                                                        color: "blue.600",
                                                      }}
                                                    >
                                                      <MdFileDownload size="22px" />
                                                    </Button>
                                                  </Text>
                                                ) : (
                                                  <Text textAlign="center">
                                                    -
                                                  </Text>
                                                )}
                                                {hist.id_arq_comprob ? (
                                                  <Text textAlign="center">
                                                    <Button
                                                      onClick={() => {
                                                        // onOpen();
                                                        // setClick(
                                                        //   "histComprobatorios",
                                                        // );
                                                        // setObservacao(hist);
                                                        download(
                                                          hist.hash_arq_comprob,
                                                        );
                                                      }}
                                                      colorScheme="unset"
                                                      variant="solid"
                                                      padding="0"
                                                      color="#555"
                                                      _hover={{
                                                        backgroundColor:
                                                          "#cad8eb",
                                                        color: "blue.600",
                                                      }}
                                                    >
                                                      <MdFileDownload size="22px" />
                                                    </Button>
                                                  </Text>
                                                ) : (
                                                  <Text textAlign="center">
                                                    -
                                                  </Text>
                                                )}

                                                <Text
                                                  display="flex"
                                                  gridColumnGap="3px"
                                                >
                                                  <span>R$</span>
                                                  <NumberFormat
                                                    readOnly
                                                    decimalScale={2}
                                                    decimalSeparator=","
                                                    fixedDecimalScale
                                                    thousandSeparator="."
                                                    value={hist.valor}
                                                    style={{
                                                      width: "max-content",
                                                      background: "none",
                                                    }}
                                                  />
                                                </Text>

                                                {hist.observacao ? (
                                                  <Text textAlign="center">
                                                    <Button
                                                      onClick={() => {
                                                        onOpen();
                                                        setClick("observacao");
                                                        setObservacao(hist);
                                                      }}
                                                      colorScheme="unset"
                                                      variant="solid"
                                                      padding="0"
                                                      color="#555"
                                                      _hover={{
                                                        backgroundColor:
                                                          "#cad8eb",
                                                        color: "blue.600",
                                                      }}
                                                    >
                                                      <BiCommentDetail size="22px" />
                                                    </Button>
                                                  </Text>
                                                ) : (
                                                  <Text textAlign="center">
                                                    -
                                                  </Text>
                                                )}

                                                {hist.id_arq_boleto ? (
                                                  <Text textAlign="center">
                                                    <Button
                                                      onClick={() => {
                                                        onOpen();
                                                        setClick(
                                                          "histBoletoNota",
                                                        );
                                                        setObservacao(hist);
                                                      }}
                                                      colorScheme="unset"
                                                      variant="solid"
                                                      padding="0"
                                                      color="#555"
                                                      _hover={{
                                                        backgroundColor:
                                                          "#cad8eb",
                                                        color: "blue.600",
                                                      }}
                                                    >
                                                      <RiFileTextLine
                                                        size="22px"
                                                        color="#2160b8"
                                                      />
                                                    </Button>
                                                  </Text>
                                                ) : (
                                                  <Text textAlign="center">
                                                    -
                                                  </Text>
                                                )}
                                              </Box>
                                            ))}
                                        </Box>
                                      </>
                                    ) : (
                                      <Text
                                        padding="5px 5px 0"
                                        fontSize="18px"
                                        fontWeight="bold"
                                      >
                                        Sem Histórico
                                      </Text>
                                    )}
                                  </Box>
                                </AccordionPanel>
                              </AccordionItem>
                            ))}
                        </Accordion>
                      </Box>

                      <Modal
                        scrollBehavior="inside"
                        isCentered
                        onClose={() => {
                          reset();
                          setValor(null);
                          setClick(null);
                          setObservacao(null);
                          setisEditing(false);
                          setInputObservacaoEdit("");
                          setInputValorEdit(null);
                          setActiveStep(0);
                          setNewObservation(null);
                          setInputFileEdit(null);
                          setInputFileComp(null);
                          setEditLoading(false);
                          setNewFile(false);
                          setNewFileComp(false);
                          setChangeSend(false);
                          onClose();
                        }}
                        isOpen={isOpen}
                        motionPreset="slideInBottom"
                      >
                        <ModalOverlay />
                        <ModalContent>
                          {click && click === "editar" ? (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status={
                                    observacao.status_documento === 2 ||
                                    observacao.status_documento?.id === 2
                                      ? "info"
                                      : "error"
                                  }
                                >
                                  <AlertIcon />
                                  {observacao.status_documento === 2 ||
                                  observacao.status_documento?.id === 2
                                    ? "Enviado. Aguarde validação"
                                    : "Negado. Aguardando reenvio"}
                                </Alert>
                                <Divider />
                                <Box
                                  fontSize="14px"
                                  fontWeight="500"
                                  display="flex"
                                  gridColumnGap="10px"
                                  justifyContent="space-between"
                                >
                                  <Text>
                                    Usuário:{" "}
                                    {
                                      observacao.hist_validacao_docs[0]
                                        .users_permissions_user?.nome
                                    }
                                  </Text>
                                  <Text>
                                    Data:{" "}
                                    {moment(observacao.updated_at).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>
                                  <Text>
                                    Hora:{" "}
                                    {moment(observacao.updated_at).format(
                                      "HH:mm",
                                    )}
                                  </Text>
                                </Box>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <Grid gap={6}>
                                  <Box fontWeight="500">
                                    Competência: {observacao.mes_competencia}/
                                    {observacao.ano_competencia}
                                  </Box>
                                  <FormControl>
                                    {!isEditing ? (
                                      <>
                                        <FormLabel htmlFor="arquivo">
                                          Arquivo
                                        </FormLabel>
                                        <Input
                                          readOnly
                                          padding="10px"
                                          id="Arquivo"
                                          name="arquivo"
                                          value={observacao?.nome_arquivo}
                                        />
                                        <Button
                                          onClick={() =>
                                            download(observacao.hash_arquivo)
                                          }
                                          background="#f2f2f2"
                                          width="100%"
                                          margin="5px auto 0"
                                          display="flex"
                                          fontSize="18px"
                                          colorScheme="unset"
                                          variant="solid"
                                          padding="0 10px"
                                          color="#555"
                                          cursor="pointer"
                                          _hover={{
                                            backgroundColor: "#cad8eb",
                                            color: "blue.600",
                                          }}
                                        >
                                          <MdFileDownload size="25px" />
                                          <Text
                                            paddingBottom="2px"
                                            marginLeft="5px"
                                          >
                                            Baixar arquivo
                                          </Text>
                                        </Button>

                                        {observacao.hist_validacao_docs.sort(
                                          sortDESC,
                                        )[0].id_arq_comprob && (
                                          <>
                                            <Divider marginTop="10px" />

                                            <FormLabel
                                              htmlFor="arquivoComp"
                                              marginTop="20px"
                                            >
                                              Arquivo comprobatório
                                            </FormLabel>
                                            <Input
                                              readOnly
                                              padding="10px"
                                              id="arquivoComp"
                                              name="arquivoComp"
                                              value={
                                                observacao.hist_validacao_docs.sort(
                                                  sortDESC,
                                                )[0].nm_arq_comprob
                                              }
                                            />
                                            <Button
                                              onClick={() =>
                                                download(
                                                  observacao.hist_validacao_docs.sort(
                                                    sortDESC,
                                                  )[0].hash_arq_comprob,
                                                )
                                              }
                                              background="#f2f2f2"
                                              width="100%"
                                              margin="5px auto 0"
                                              display="flex"
                                              fontSize="18px"
                                              colorScheme="unset"
                                              variant="solid"
                                              padding="0 10px"
                                              color="#555"
                                              cursor="pointer"
                                              _hover={{
                                                backgroundColor: "#cad8eb",
                                                color: "blue.600",
                                              }}
                                            >
                                              <MdFileDownload size="25px" />
                                              <Text
                                                paddingBottom="2px"
                                                marginLeft="5px"
                                              >
                                                Baixar arquivo comprobatório
                                              </Text>
                                            </Button>
                                          </>
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        <FormControl display="flex">
                                          <FormLabel htmlFor="newFile">
                                            Alterar arquivo da fatura?
                                          </FormLabel>
                                          <Switch
                                            isChecked={newFile}
                                            onChange={() => {
                                              setInputFileEdit(null);
                                              if (!newFile) {
                                                Swal.fire({
                                                  title:
                                                    "Essa alteração substituirá o arquivo anexado anteriormente, deseja continuar?",
                                                  showCancelButton: true,
                                                  confirmButtonText: "Sim",
                                                  cancelButtonText: "Cancelar",
                                                }).then(async (result) => {
                                                  if (result.isConfirmed) {
                                                    setNewFile(true);
                                                  } else {
                                                    setNewFile(false);
                                                  }
                                                });
                                              } else {
                                                setNewFile(!newFile);
                                              }
                                            }}
                                            id="newFile"
                                            style={{ outline: "0 !important" }}
                                          />
                                        </FormControl>

                                        {newFile && (
                                          <>
                                            <FormControl
                                              isInvalid={
                                                inputFileEdit
                                                  ? inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "png" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "jpg" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "jpeg" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "zip" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "pdf" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "img" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "docx" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "doc" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "xlsx" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "xls" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "csv" ||
                                                    inputFileEdit?.name.split(
                                                      ".",
                                                    )[1] === "rar"
                                                    ? false
                                                    : true
                                                  : false
                                              }
                                            >
                                              <FormLabel htmlFor="arquivo">
                                                Arquivo
                                              </FormLabel>
                                              <Input
                                                color="blue.600"
                                                padding="5px"
                                                id="Arquivo"
                                                name="arquivo"
                                                type="file"
                                                onChange={(e: any) =>
                                                  setInputFileEdit(
                                                    e.target.files[0],
                                                  )
                                                }
                                              />
                                              <FormErrorMessage fontWeight="500">
                                                * Tipos de arquivos permitidos
                                                (PDF, JPEG, PNG, IMG, DOCX, DOC,
                                                XLSX, XLS, CSV, RAR, ZIP)
                                              </FormErrorMessage>
                                            </FormControl>
                                          </>
                                        )}
                                        {(observacao.id_arq_comprob ||
                                          observacao.status_documento === 3 ||
                                          observacao.status_documento?.id ===
                                            3) && (
                                          <>
                                            <Divider marginTop="10px" />
                                            <FormControl
                                              display="flex"
                                              marginTop="20px"
                                            >
                                              <FormLabel htmlFor="newFileComp">
                                                Deseja incluir documentos
                                                comprobatórios?
                                              </FormLabel>
                                              <Switch
                                                isChecked={newFileComp}
                                                onChange={() => {
                                                  setInputFileComp(null);
                                                  if (!newFileComp) {
                                                    setNewFileComp(true);
                                                  } else {
                                                    setNewFileComp(
                                                      !newFileComp,
                                                    );
                                                  }
                                                }}
                                                id="newFileComp"
                                                style={{
                                                  outline: "0 !important",
                                                }}
                                              />
                                            </FormControl>

                                            {newFileComp && (
                                              <>
                                                <FormControl
                                                  isInvalid={
                                                    inputFileComp
                                                      ? inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "png" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "jpg" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "jpeg" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "zip" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "pdf" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "img" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "docx" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "doc" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "xlsx" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "xls" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "csv" ||
                                                        inputFileComp?.name.split(
                                                          ".",
                                                        )[1] === "rar"
                                                        ? false
                                                        : true
                                                      : false
                                                  }
                                                >
                                                  <FormLabel htmlFor="arquivoComp">
                                                    Arquivo
                                                  </FormLabel>
                                                  <Input
                                                    color="blue.600"
                                                    padding="5px"
                                                    id="arquivoComp"
                                                    name="arquivoComp"
                                                    type="file"
                                                    onChange={(e: any) =>
                                                      setInputFileComp(
                                                        e.target.files[0],
                                                      )
                                                    }
                                                  />
                                                  <FormErrorMessage fontWeight="500">
                                                    * Tipos de arquivos
                                                    permitidos (PDF, JPEG, PNG,
                                                    IMG, DOCX, DOC, XLSX, XLS,
                                                    CSV, RAR, ZIP)
                                                  </FormErrorMessage>
                                                  <Text
                                                    fontWeight="500"
                                                    color="blue.600"
                                                  >
                                                    * Para incluir mais de um
                                                    arquivo, utilize a opção de
                                                    compactar pasta(.zip) do seu
                                                    computador com todos os
                                                    arquivos necessários e faça
                                                    o upload do arquivo
                                                    compactado.
                                                  </Text>
                                                </FormControl>
                                              </>
                                            )}
                                          </>
                                        )}
                                      </>
                                    )}
                                  </FormControl>

                                  <FormControl>
                                    <FormLabel htmlFor="valor">Valor</FormLabel>
                                    <InputGroup>
                                      {!isEditing ? (
                                        <>
                                          <NumberFormat
                                            readOnly
                                            decimalScale={2}
                                            decimalSeparator=","
                                            fixedDecimalScale
                                            thousandSeparator="."
                                            value={observacao.valor}
                                            prefix="R$ "
                                            style={{
                                              width: "max-content",
                                              background: "none",
                                            }}
                                            customInput={Input}
                                          />
                                        </>
                                      ) : (
                                        <NumberFormat
                                          decimalScale={2}
                                          decimalSeparator=","
                                          fixedDecimalScale
                                          placeholder="R$ 0,00"
                                          thousandSeparator="."
                                          customInput={Input}
                                          onChange={(e) =>
                                            setInputValorEdit(e.target.value)
                                          }
                                          value={inputValorEdit}
                                        />
                                      )}
                                    </InputGroup>
                                  </FormControl>
                                  {!isEditing ? (
                                    <FormControl
                                      isInvalid={
                                        observacao.status_documento === 2 ||
                                        observacao.status_documento?.id === 2
                                          ? false
                                          : true
                                      }
                                    >
                                      <FormLabel
                                        htmlFor="observacao"
                                        color={
                                          observacao.status_documento === 2 ||
                                          observacao.status_documento?.id === 2
                                            ? "unset"
                                            : "#E53E3E"
                                        }
                                      >
                                        Observação
                                      </FormLabel>
                                      <Textarea
                                        readOnly
                                        id="observacao"
                                        name="observacao"
                                        value={
                                          observacao.hist_validacao_docs.filter(
                                            (obs: any) =>
                                              obs.status_documento.id ===
                                              (observacao.status_documento ===
                                                2 ||
                                              observacao.status_documento
                                                ?.id === 2
                                                ? 2
                                                : 3),
                                          )[0].observacao
                                        }
                                      />
                                    </FormControl>
                                  ) : (
                                    <FormControl isRequired>
                                      <FormLabel htmlFor="observacao">
                                        Observação
                                      </FormLabel>
                                      <Textarea
                                        id="observacao"
                                        name="observacao"
                                        value={inputObervacaoEdit}
                                        onChange={(e) =>
                                          setInputObservacaoEdit(e.target.value)
                                        }
                                      />
                                    </FormControl>
                                  )}

                                  {!isEditing && (
                                    <Button
                                      onClick={() => setisEditing(true)}
                                      colorScheme="blue"
                                    >
                                      Editar
                                    </Button>
                                  )}
                                  {isEditing && (
                                    <Box
                                      width="100%"
                                      display="flex"
                                      gridColumnGap="15px"
                                    >
                                      <Button
                                        width="100%"
                                        onClick={() => {
                                          setisEditing(false);
                                          setInputObservacaoEdit("");
                                          setInputValorEdit(null);
                                          setInputFileEdit(null);
                                          setInputFileComp(null);
                                          setEditLoading(false);
                                          setNewFile(false);
                                          setNewFileComp(false);
                                        }}
                                        color="white"
                                        _hover={{ backgroundColor: "gray.600" }}
                                      >
                                        Cancelar
                                      </Button>
                                      <Button
                                        isLoading={editLoading}
                                        disabled={
                                          (newFileComp &&
                                            (inputFileComp === null ||
                                              (inputFileComp?.name.split(
                                                ".",
                                              )[1] === "png" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "jpg" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "jpeg" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "zip" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "pdf" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "img" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "docx" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "doc" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "xlsx" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "xls" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "csv" ||
                                              inputFileComp?.name.split(
                                                ".",
                                              )[1] === "rar"
                                                ? false
                                                : true))) ||
                                          (newFile &&
                                            (inputFileEdit === null ||
                                              (inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "png" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "jpg" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "jpeg" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "zip" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "pdf" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "img" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "docx" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "doc" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "xlsx" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "xls" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "csv" ||
                                              inputFileEdit?.name.split(
                                                ".",
                                              )[1] === "rar"
                                                ? false
                                                : true))) ||
                                          ((!newFile || !newFileComp) &&
                                            (inputValorEdit?.length < 1 ||
                                              inputValorEdit === null) &&
                                            (inputObervacaoEdit?.length < 1 ||
                                              inputObervacaoEdit === ""))
                                        }
                                        width="100%"
                                        colorScheme="blue"
                                        onClick={() => handleEditDocument()}
                                      >
                                        Enviar
                                      </Button>
                                    </Box>
                                  )}
                                </Grid>
                              </ModalBody>
                              <ModalFooter></ModalFooter>
                            </>
                          ) : click && click === "histBoletoNota" ? (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status="info"
                                >
                                  <AlertIcon />
                                  Boleto e nota disponíveis
                                </Alert>
                                <Divider />
                                <Box
                                  fontSize="14px"
                                  fontWeight="500"
                                  display="flex"
                                  gridColumnGap="10px"
                                  justifyContent="space-between"
                                >
                                  <Text>
                                    Usuário:{" "}
                                    {observacao.users_permissions_user?.nome}
                                  </Text>
                                  <Text>
                                    Data:{" "}
                                    {moment(observacao.updated_at).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>
                                  <Text>
                                    Hora:{" "}
                                    {moment(observacao.updated_at).format(
                                      "HH:mm",
                                    )}
                                  </Text>
                                </Box>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <Grid gap={6}>
                                  <FormControl>
                                    <FormLabel htmlFor="arquivo">
                                      Boleto
                                    </FormLabel>
                                    <Input
                                      readOnly
                                      padding="10px"
                                      id="Arquivo"
                                      name="arquivo"
                                      value={observacao.nm_arq_boleto}
                                    />
                                    <Button
                                      onClick={() =>
                                        download(observacao.hash_arq_boleto)
                                      }
                                      background="#f2f2f2"
                                      width="100%"
                                      margin="5px auto 0"
                                      display="flex"
                                      fontSize="18px"
                                      colorScheme="unset"
                                      variant="solid"
                                      padding="0 10px"
                                      color="#555"
                                      cursor="pointer"
                                      _hover={{
                                        backgroundColor: "#cad8eb",
                                        color: "blue.600",
                                      }}
                                    >
                                      <MdFileDownload size="25px" />
                                      <Text
                                        paddingBottom="2px"
                                        marginLeft="5px"
                                      >
                                        Baixar boleto
                                      </Text>
                                    </Button>
                                    <FormLabel
                                      htmlFor="arquivo"
                                      marginTop="20px"
                                    >
                                      Nota
                                    </FormLabel>
                                    <Input
                                      readOnly
                                      padding="10px"
                                      id="Arquivo"
                                      name="arquivo"
                                      value={observacao.nm_arq_nota}
                                    />
                                    <Button
                                      onClick={() =>
                                        download(observacao.hash_arq_nota)
                                      }
                                      background="#f2f2f2"
                                      width="100%"
                                      margin="5px auto 0"
                                      display="flex"
                                      fontSize="18px"
                                      colorScheme="unset"
                                      variant="solid"
                                      padding="0 10px"
                                      color="#555"
                                      cursor="pointer"
                                      _hover={{
                                        backgroundColor: "#cad8eb",
                                        color: "blue.600",
                                      }}
                                    >
                                      <MdFileDownload size="25px" />
                                      <Text
                                        paddingBottom="2px"
                                        marginLeft="5px"
                                      >
                                        Baixar nota
                                      </Text>
                                    </Button>
                                  </FormControl>
                                </Grid>
                              </ModalBody>
                              <ModalFooter></ModalFooter>
                            </>
                          ) : click && click === "editBoleto" ? (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status="info"
                                >
                                  <AlertIcon />
                                  Boleto e nota disponíveis
                                </Alert>
                                <Divider />
                                <Box
                                  fontSize="14px"
                                  fontWeight="500"
                                  display="flex"
                                  gridColumnGap="10px"
                                  justifyContent="space-between"
                                >
                                  <Text>
                                    Usuário:{" "}
                                    {
                                      observacao.hist_validacao_docs[0]
                                        .users_permissions_user?.nome
                                    }
                                  </Text>
                                  <Text>
                                    Data:{" "}
                                    {moment(observacao.updated_at).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>
                                  <Text>
                                    Hora:{" "}
                                    {moment(observacao.updated_at).format(
                                      "HH:mm",
                                    )}
                                  </Text>
                                </Box>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <Grid gap={6}>
                                  <Box fontWeight="500">
                                    Competência: {observacao.mes_competencia}/
                                    {observacao.ano_competencia}
                                  </Box>
                                  {!isEditing ? (
                                    <>
                                      <FormControl>
                                        <FormLabel htmlFor="arquivo">
                                          Boleto
                                        </FormLabel>
                                        <Input
                                          readOnly
                                          padding="10px"
                                          id="Arquivo"
                                          name="arquivo"
                                          value={observacao.nm_arq_boleto}
                                        />
                                        <Button
                                          onClick={() =>
                                            download(observacao.hash_arq_boleto)
                                          }
                                          background="#f2f2f2"
                                          width="100%"
                                          margin="5px auto 0"
                                          display="flex"
                                          fontSize="18px"
                                          colorScheme="unset"
                                          variant="solid"
                                          padding="0 10px"
                                          color="#555"
                                          cursor="pointer"
                                          _hover={{
                                            backgroundColor: "#cad8eb",
                                            color: "blue.600",
                                          }}
                                        >
                                          <MdFileDownload size="25px" />
                                          <Text
                                            paddingBottom="2px"
                                            marginLeft="5px"
                                          >
                                            Baixar boleto
                                          </Text>
                                        </Button>
                                        <FormLabel
                                          htmlFor="arquivo"
                                          marginTop="20px"
                                        >
                                          Nota
                                        </FormLabel>
                                        <Input
                                          readOnly
                                          padding="10px"
                                          id="Arquivo"
                                          name="arquivo"
                                          value={observacao.nm_arq_nota}
                                        />
                                        <Button
                                          onClick={() =>
                                            download(observacao.hash_arq_nota)
                                          }
                                          background="#f2f2f2"
                                          width="100%"
                                          margin="5px auto 0"
                                          display="flex"
                                          fontSize="18px"
                                          colorScheme="unset"
                                          variant="solid"
                                          padding="0 10px"
                                          color="#555"
                                          cursor="pointer"
                                          _hover={{
                                            backgroundColor: "#cad8eb",
                                            color: "blue.600",
                                          }}
                                        >
                                          <MdFileDownload size="25px" />
                                          <Text
                                            paddingBottom="2px"
                                            marginLeft="5px"
                                          >
                                            Baixar nota
                                          </Text>
                                        </Button>
                                      </FormControl>
                                    </>
                                  ) : (
                                    <>
                                      <FormControl
                                        isRequired
                                        isInvalid={
                                          fileBoleto || fileNota
                                            ? fileBoleto?.name.split(".")[1] ===
                                                "png" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "jpg" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "jpeg" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "zip" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "pdf" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "img" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "docx" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "doc" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "xlsx" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "xls" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "csv" ||
                                              fileBoleto?.name.split(".")[1] ===
                                                "rar"
                                              ? false
                                              : true
                                            : false
                                        }
                                      >
                                        <FormLabel htmlFor="boleto_edit">
                                          Boleto
                                        </FormLabel>
                                        <Input
                                          color="blue.600"
                                          padding="5px"
                                          id="boleto_edit"
                                          name="boleto"
                                          type="file"
                                          onChange={(e: any) => {
                                            setFileBoleto(e.target.files[0]);
                                          }}
                                        />
                                        <FormErrorMessage fontWeight="500">
                                          * Tipos de arquivos permitidos (PDF,
                                          JPEG, PNG, IMG, DOCX, DOC, XLSX, XLS,
                                          CSV, RAR, ZIP)
                                        </FormErrorMessage>
                                      </FormControl>
                                      <FormControl
                                        isRequired
                                        isInvalid={
                                          fileBoleto || fileNota
                                            ? fileNota?.name.split(".")[1] ===
                                                "png" ||
                                              fileNota?.name.split(".")[1] ===
                                                "jpg" ||
                                              fileNota?.name.split(".")[1] ===
                                                "jpeg" ||
                                              fileNota?.name.split(".")[1] ===
                                                "zip" ||
                                              fileNota?.name.split(".")[1] ===
                                                "pdf" ||
                                              fileNota?.name.split(".")[1] ===
                                                "img" ||
                                              fileNota?.name.split(".")[1] ===
                                                "docx" ||
                                              fileNota?.name.split(".")[1] ===
                                                "doc" ||
                                              fileNota?.name.split(".")[1] ===
                                                "xlsx" ||
                                              fileNota?.name.split(".")[1] ===
                                                "xls" ||
                                              fileNota?.name.split(".")[1] ===
                                                "csv" ||
                                              fileNota?.name.split(".")[1] ===
                                                "rar"
                                              ? false
                                              : true
                                            : false
                                        }
                                      >
                                        <FormLabel
                                          htmlFor="nota_edit"
                                          marginTop="20px"
                                        >
                                          Nota
                                        </FormLabel>
                                        <Input
                                          color="blue.600"
                                          padding="5px"
                                          id="nota_edit"
                                          name="nota"
                                          type="file"
                                          onChange={(e: any) =>
                                            setFileNota(e.target.files[0])
                                          }
                                        />
                                        <FormErrorMessage fontWeight="500">
                                          * Tipos de arquivos permitidos (PDF,
                                          JPEG, PNG, IMG, DOCX, DOC, XLSX, XLS,
                                          CSV, RAR, ZIP)
                                        </FormErrorMessage>
                                      </FormControl>
                                    </>
                                  )}

                                  {!isEditing && (
                                    <Button
                                      onClick={() => {
                                        setFileBoleto(null);
                                        setFileNota(null);

                                        Swal.fire({
                                          title:
                                            "Esses arquivos já foram disponibilizados para o contratante realizar o download e o pagamento, verifique a necessidade de entrar em contato com o contratante para evitar possíveis erros. Deseja continuar?",
                                          showCancelButton: true,
                                          confirmButtonText: "Sim",
                                          cancelButtonText: "Cancelar",
                                        }).then(async (result) => {
                                          if (result.isConfirmed) {
                                            setisEditing(true);
                                          } else {
                                            setisEditing(false);
                                          }
                                        });
                                      }}
                                      colorScheme="blue"
                                    >
                                      Editar
                                    </Button>
                                  )}
                                  {isEditing && (
                                    <Box
                                      width="100%"
                                      display="flex"
                                      gridColumnGap="15px"
                                    >
                                      <Button
                                        width="100%"
                                        onClick={() => {
                                          setisEditing(false);
                                          setInputObservacaoEdit("");
                                          setInputValorEdit(null);
                                          setFileBoleto(null);
                                          setFileNota(null);
                                          setEditLoading(false);
                                          setNewFile(false);
                                          setNewFileComp(false);
                                        }}
                                        color="white"
                                        _hover={{ backgroundColor: "gray.600" }}
                                      >
                                        Cancelar
                                      </Button>
                                      <Button
                                        isLoading={isSending}
                                        disabled={
                                          fileBoleto === null ||
                                          fileNota === null ||
                                          (fileBoleto?.name.split(".")[1] ===
                                            "png" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "jpg" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "jpeg" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "zip" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "pdf" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "img" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "docx" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "doc" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "xlsx" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "xls" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "csv" ||
                                          fileBoleto?.name.split(".")[1] ===
                                            "rar"
                                            ? false
                                            : true) ||
                                          (fileNota?.name.split(".")[1] ===
                                            "png" ||
                                          fileNota?.name.split(".")[1] ===
                                            "jpg" ||
                                          fileNota?.name.split(".")[1] ===
                                            "jpeg" ||
                                          fileNota?.name.split(".")[1] ===
                                            "zip" ||
                                          fileNota?.name.split(".")[1] ===
                                            "pdf" ||
                                          fileNota?.name.split(".")[1] ===
                                            "img" ||
                                          fileNota?.name.split(".")[1] ===
                                            "docx" ||
                                          fileNota?.name.split(".")[1] ===
                                            "doc" ||
                                          fileNota?.name.split(".")[1] ===
                                            "xlsx" ||
                                          fileNota?.name.split(".")[1] ===
                                            "xls" ||
                                          fileNota?.name.split(".")[1] ===
                                            "csv" ||
                                          fileNota?.name.split(".")[1] === "rar"
                                            ? false
                                            : true)
                                        }
                                        width="100%"
                                        colorScheme="blue"
                                        onClick={() => sendFileBoletoNota()}
                                      >
                                        Enviar
                                      </Button>
                                    </Box>
                                  )}
                                </Grid>
                              </ModalBody>
                              <ModalFooter></ModalFooter>
                            </>
                          ) : click && click === "editarStatus" ? (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status={
                                    observacao.status_documento === 3 ||
                                    observacao.status_documento?.id === 3
                                      ? "error"
                                      : observacao.status_documento === 8 ||
                                        observacao.status_documento?.id === 8
                                      ? "warning"
                                      : "success"
                                  }
                                >
                                  <AlertIcon />
                                  {observacao.status_documento === 3 ||
                                  observacao.status_documento?.id === 3
                                    ? "Negado. Aguardando reenvio"
                                    : observacao.status_documento === 4 ||
                                      observacao.status_documento?.id === 4
                                    ? "Validado"
                                    : (observacao.status_documento === 8 ||
                                        observacao.status_documento?.id ===
                                          8) &&
                                      "Validado com pendência"}
                                </Alert>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody marginTop="-15px">
                                <Stepper
                                  activeStep={activeStep}
                                  orientation="vertical"
                                >
                                  <Step key="1">
                                    <StepLabel>
                                      <Text fontSize="16px">Informações</Text>
                                    </StepLabel>
                                    <StepContent>
                                      <Text fontSize="18px" fontWeight="500">
                                        Dados da Pessoa Jurídica
                                      </Text>
                                      <Divider margin="0 0 10px" />
                                      <Box fontSize="17px">
                                        <Box display="flex" gridColumnGap="5px">
                                          Usuário:
                                          <Text fontWeight="500">
                                            {
                                              observacao.hist_validacao_docs[0]
                                                .users_permissions_user?.nome
                                            }
                                          </Text>
                                        </Box>
                                        <Box display="flex" gridColumnGap="5px">
                                          Data:{" "}
                                          <Text fontWeight="500">
                                            {moment(
                                              observacao.updated_at,
                                            ).format("DD/MM/YYYY")}
                                          </Text>
                                        </Box>
                                        <Divider margin="10px 0" />
                                        {observacao.hist_validacao_docs.sort(
                                          sortDESC,
                                        )[0].id_arq_comprob && (
                                          <>
                                            <Box
                                              display="flex"
                                              gridColumnGap="5px"
                                            >
                                              <Text fontWeight="500">
                                                Arquivo comprobratório:{" "}
                                                {
                                                  observacao.hist_validacao_docs.sort(
                                                    sortDESC,
                                                  )[0].nm_arq_comprob
                                                }
                                              </Text>
                                            </Box>
                                            <Button
                                              onClick={() =>
                                                download(
                                                  observacao.hist_validacao_docs.sort(
                                                    sortDESC,
                                                  )[0].hash_arq_comprob,
                                                )
                                              }
                                              background="#f2f2f2"
                                              width="100%"
                                              margin="0 auto"
                                              display="flex"
                                              fontSize="18px"
                                              colorScheme="unset"
                                              variant="solid"
                                              padding="0 10px"
                                              color="#555"
                                              cursor="pointer"
                                              _hover={{
                                                backgroundColor: "#cad8eb",
                                                color: "blue.600",
                                              }}
                                            >
                                              <MdFileDownload size="25px" />
                                              <Text
                                                paddingBottom="2px"
                                                marginLeft="5px"
                                              >
                                                Baixar arquivo comprobatório
                                              </Text>
                                            </Button>
                                          </>
                                        )}
                                        {observacao.hist_validacao_docs[0]
                                          .observacao?.length > 0 && (
                                          <>
                                            <Text
                                              color={
                                                observacao.status_documento ===
                                                  8 ||
                                                observacao.status_documento
                                                  ?.id === 8
                                                  ? "#E53E3E"
                                                  : "unset"
                                              }
                                            >
                                              Observação:
                                            </Text>
                                            <Text
                                              backgroundColor="#f2f2f2"
                                              textAlign="center"
                                              fontSize="18px"
                                              padding="20px 10px"
                                              marginBottom="15px"
                                              border={
                                                observacao.status_documento ===
                                                  8 ||
                                                observacao.status_documento
                                                  ?.id === 8
                                                  ? "1px solid #E53E3E"
                                                  : "unset"
                                              }
                                            >
                                              {
                                                observacao
                                                  .hist_validacao_docs[0]
                                                  .observacao
                                              }
                                            </Text>
                                          </>
                                        )}

                                        <Text
                                          fontSize="18px"
                                          fontWeight="500"
                                          margin="40px 0 0"
                                        >
                                          Dados da InterBrasil
                                        </Text>
                                        <Divider margin="0 0 10px" />
                                        <Box display="flex" gridColumnGap="5px">
                                          Usuário:{" "}
                                          <Text fontWeight="500">
                                            {
                                              observacao.hist_validacao_docs[
                                                observacao.hist_validacao_docs
                                                  .length - 1
                                              ].users_permissions_user?.nome
                                            }
                                          </Text>
                                        </Box>
                                        <Box display="flex" gridColumnGap="5px">
                                          Data de envio:{" "}
                                          <Text fontWeight="500">
                                            {moment(
                                              observacao.hist_validacao_docs[
                                                observacao.hist_validacao_docs
                                                  .length - 1
                                              ].created_at,
                                            ).format("DD/MM/YYYY")}
                                          </Text>
                                        </Box>
                                        {/* <Box display="flex" gridColumnGap="5px">
                                          Hora:{" "}
                                          <Text fontWeight="500">
                                            {moment(
                                              observacao.updated_at,
                                            ).format("HH:mm")}
                                          </Text>
                                        </Box> */}
                                        <Box display="flex" gridColumnGap="5px">
                                          Fatura:{" "}
                                          <Text fontWeight="500">
                                            {observacao?.nome_arquivo}
                                          </Text>
                                        </Box>
                                        <Button
                                          onClick={() =>
                                            download(observacao.hash_arquivo)
                                          }
                                          background="#f2f2f2"
                                          width="100%"
                                          margin="0 auto"
                                          display="flex"
                                          fontSize="18px"
                                          colorScheme="unset"
                                          variant="solid"
                                          padding="0 10px"
                                          color="#555"
                                          cursor="pointer"
                                          _hover={{
                                            backgroundColor: "#cad8eb",
                                            color: "blue.600",
                                          }}
                                        >
                                          <MdFileDownload size="25px" />
                                          <Text
                                            paddingBottom="2px"
                                            marginLeft="5px"
                                          >
                                            Baixar fatura
                                          </Text>
                                        </Button>
                                        <Box
                                          display="flex"
                                          gridColumnGap="5px"
                                          marginTop="15px"
                                        >
                                          Valor:
                                          <Text fontWeight="500">
                                            R$
                                            <NumberFormat
                                              readOnly
                                              decimalScale={2}
                                              decimalSeparator=","
                                              fixedDecimalScale
                                              thousandSeparator="."
                                              value={observacao.valor}
                                              style={{
                                                width: "max-content",
                                                background: "none",
                                                fontWeight: "bold",
                                              }}
                                            />
                                          </Text>
                                        </Box>
                                      </Box>
                                      <Box
                                        display="flex"
                                        gridColumnGap="10px"
                                        justifyContent="end"
                                        margin="20px 0 0"
                                      >
                                        <Button
                                          onClick={handleNext}
                                          fontWeight="500"
                                          colorScheme="blue"
                                        >
                                          Alterar Status
                                        </Button>
                                      </Box>
                                    </StepContent>
                                  </Step>

                                  <Step key="2">
                                    <StepLabel>
                                      <Text fontSize="16px">Status</Text>
                                    </StepLabel>
                                    <StepContent>
                                      <Box>
                                        <RadioGroup
                                          onChange={setStatus}
                                          value={status}
                                        >
                                          <Stack
                                            direction="column"
                                            fontWeight="500"
                                            margin="10px 0 30px"
                                          >
                                            <Radio value="2" cursor="pointer">
                                              <Text cursor="pointer">
                                                Aguardando validação
                                              </Text>
                                            </Radio>
                                          </Stack>
                                        </RadioGroup>

                                        <FormControl
                                          display="flex"
                                          marginTop="20px"
                                        >
                                          <FormLabel htmlFor="newFileComp">
                                            Deseja incluir documentos
                                            comprobatórios?
                                          </FormLabel>
                                          <Switch
                                            isChecked={newFileComp}
                                            onChange={() => {
                                              setInputFileComp(null);
                                              if (!newFileComp) {
                                                setNewFileComp(true);
                                              } else {
                                                setNewFileComp(!newFileComp);
                                              }
                                            }}
                                            id="newFileComp"
                                            style={{
                                              outline: "0 !important",
                                            }}
                                          />
                                        </FormControl>

                                        {newFileComp && (
                                          <>
                                            <FormControl
                                              isInvalid={
                                                inputFileComp
                                                  ? inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "png" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "jpg" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "jpeg" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "zip" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "pdf" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "img" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "docx" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "doc" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "xlsx" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "xls" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "csv" ||
                                                    inputFileComp?.name.split(
                                                      ".",
                                                    )[1] === "rar"
                                                    ? false
                                                    : true
                                                  : false
                                              }
                                            >
                                              <FormLabel htmlFor="arquivoComp">
                                                Arquivo
                                              </FormLabel>
                                              <Input
                                                color="blue.600"
                                                padding="5px"
                                                id="arquivoComp"
                                                name="arquivoComp"
                                                type="file"
                                                onChange={(e: any) =>
                                                  setInputFileComp(
                                                    e.target.files[0],
                                                  )
                                                }
                                              />
                                              <FormErrorMessage fontWeight="500">
                                                * Tipos de arquivos permitidos
                                                (PDF, JPEG, PNG, IMG, DOCX, DOC,
                                                XLSX, XLS, CSV, RAR, ZIP)
                                              </FormErrorMessage>
                                              <Text
                                                fontWeight="500"
                                                color="blue.600"
                                              >
                                                * Para incluir mais de um
                                                arquivo, utilize a opção de
                                                compactar pasta(.zip) do seu
                                                computador com todos os arquivos
                                                necessários e faça o upload do
                                                arquivo compactado.
                                              </Text>
                                            </FormControl>
                                          </>
                                        )}

                                        <Divider margin="20px 0" />

                                        <FormControl isRequired>
                                          <FormLabel htmlFor="observacao">
                                            Observação
                                          </FormLabel>
                                          <Textarea
                                            required
                                            id="observacao"
                                            placeholder="Digite a observação"
                                            onChange={(e: any) =>
                                              setNewObservation(e.target.value)
                                            }
                                            value={newObservation}
                                          />
                                        </FormControl>
                                      </Box>
                                      <Box
                                        display="flex"
                                        gridColumnGap="10px"
                                        justifyContent="end"
                                        margin="20px 0 0"
                                      >
                                        <Button
                                          onClick={handleBack}
                                          color="white"
                                          _hover={{
                                            backgroundColor: "gray.600",
                                          }}
                                        >
                                          Voltar
                                        </Button>
                                        <Button
                                          isLoading={isSending}
                                          onClick={() => sendStatus()}
                                          fontWeight="500"
                                          colorScheme="blue"
                                          disabled={
                                            !newObservation ||
                                            !status ||
                                            (newFileComp &&
                                              (inputFileComp === null ||
                                                (inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "png" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "jpg" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "jpeg" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "zip" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "pdf" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "img" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "docx" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "doc" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "xlsx" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "xls" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "csv" ||
                                                inputFileComp?.name.split(
                                                  ".",
                                                )[1] === "rar"
                                                  ? false
                                                  : true)))
                                          }
                                        >
                                          Confirmar
                                        </Button>
                                      </Box>
                                    </StepContent>
                                  </Step>
                                </Stepper>
                              </ModalBody>
                            </>
                          ) : click && click === "enviar" ? (
                            <>
                              <ModalHeader>
                                Enviar arquivo de extrato
                                <br />
                                <Box
                                  fontSize="14px"
                                  color="#E53E3E"
                                  fontWeight="100"
                                  marginTop="10px"
                                >
                                  (*) indica os campos obrigatórios
                                </Box>
                              </ModalHeader>

                              <ModalCloseButton />
                              <ModalBody>
                                <form
                                  onSubmit={handleSubmit(sendFile)}
                                  onReset={(event) => {
                                    event.preventDefault();
                                    reset(defaultValues);
                                  }}
                                >
                                  <Grid gap={6}>
                                    <Box fontWeight="500">
                                      Competência: {observacao.mes_competencia}/
                                      {observacao.ano_competencia}
                                    </Box>
                                    <FormControl
                                      isRequired
                                      isInvalid={
                                        file
                                          ? file?.name.split(".")[1] ===
                                              "png" ||
                                            file?.name.split(".")[1] ===
                                              "jpg" ||
                                            file?.name.split(".")[1] ===
                                              "jpeg" ||
                                            file?.name.split(".")[1] ===
                                              "zip" ||
                                            file?.name.split(".")[1] ===
                                              "pdf" ||
                                            file?.name.split(".")[1] ===
                                              "img" ||
                                            file?.name.split(".")[1] ===
                                              "docx" ||
                                            file?.name.split(".")[1] ===
                                              "doc" ||
                                            file?.name.split(".")[1] ===
                                              "xlsx" ||
                                            file?.name.split(".")[1] ===
                                              "xls" ||
                                            file?.name.split(".")[1] ===
                                              "csv" ||
                                            file?.name.split(".")[1] === "rar"
                                            ? false
                                            : true
                                          : false
                                      }
                                    >
                                      <FormLabel htmlFor="arquivo">
                                        Arquivo
                                      </FormLabel>
                                      <Input
                                        color="blue.600"
                                        padding="5px"
                                        id="Arquivo"
                                        name="arquivo"
                                        type="file"
                                        onChange={(e: any) =>
                                          setFile(e.target.files[0])
                                        }
                                      />
                                      <FormErrorMessage fontWeight="500">
                                        * Tipos de arquivos permitidos (PDF,
                                        JPEG, PNG, IMG, DOCX, DOC, XLSX, XLS,
                                        CSV, RAR, ZIP)
                                      </FormErrorMessage>
                                    </FormControl>

                                    <FormControl isRequired>
                                      <FormLabel htmlFor="valor">
                                        Valor
                                      </FormLabel>
                                      <InputGroup>
                                        <NumberFormat
                                          decimalScale={2}
                                          decimalSeparator=","
                                          fixedDecimalScale
                                          placeholder="R$ 0,00"
                                          thousandSeparator="."
                                          customInput={Input}
                                          onChange={(e: any) =>
                                            setValor(e.target.value)
                                          }
                                        />
                                      </InputGroup>
                                    </FormControl>

                                    <FormControl>
                                      <FormLabel htmlFor="observacao">
                                        Observação
                                      </FormLabel>
                                      <Textarea
                                        id="observacao"
                                        {...register("observacao")}
                                        placeholder="Digite a observação"
                                      />
                                    </FormControl>
                                    <Button
                                      colorScheme="blue"
                                      isLoading={isSending}
                                      type="submit"
                                      disabled={
                                        !!errors.valor ||
                                        (file?.name.split(".")[1] === "png" ||
                                        file?.name.split(".")[1] === "jpg" ||
                                        file?.name.split(".")[1] === "jpeg" ||
                                        file?.name.split(".")[1] === "zip" ||
                                        file?.name.split(".")[1] === "pdf" ||
                                        file?.name.split(".")[1] === "img" ||
                                        file?.name.split(".")[1] === "docx" ||
                                        file?.name.split(".")[1] === "doc" ||
                                        file?.name.split(".")[1] === "xlsx" ||
                                        file?.name.split(".")[1] === "xls" ||
                                        file?.name.split(".")[1] === "csv" ||
                                        file?.name.split(".")[1] === "rar"
                                          ? false
                                          : true)
                                      }
                                    >
                                      Enviar
                                    </Button>
                                  </Grid>
                                </form>
                              </ModalBody>
                              <ModalFooter></ModalFooter>
                            </>
                          ) : click && click === "uploadBoleto" ? (
                            <>
                              <ModalHeader>
                                Enviar boleto e nota
                                <br />
                                <Box
                                  fontSize="14px"
                                  color="#E53E3E"
                                  fontWeight="100"
                                  marginTop="10px"
                                >
                                  (*) indica os campos obrigatórios
                                </Box>
                              </ModalHeader>

                              <ModalCloseButton />
                              <ModalBody>
                                <form
                                  onSubmit={handleSubmit(sendFileBoletoNota)}
                                  onReset={(event) => {
                                    event.preventDefault();
                                    reset(defaultValues);
                                  }}
                                >
                                  <Grid gap={6}>
                                    <Box fontWeight="500">
                                      Competência: {observacao.mes_competencia}/
                                      {observacao.ano_competencia}
                                    </Box>
                                    <FormControl
                                      isRequired
                                      isInvalid={
                                        fileBoleto || fileNota
                                          ? fileBoleto?.name.split(".")[1] ===
                                              "png" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "jpg" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "jpeg" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "zip" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "pdf" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "img" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "docx" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "doc" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "xlsx" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "xls" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "csv" ||
                                            fileBoleto?.name.split(".")[1] ===
                                              "rar"
                                            ? false
                                            : true
                                          : false
                                      }
                                    >
                                      <FormLabel htmlFor="boleto">
                                        Arquivo do boleto
                                      </FormLabel>
                                      <Input
                                        color="blue.600"
                                        padding="5px"
                                        id="boleto"
                                        name="boleto"
                                        type="file"
                                        onChange={(e: any) =>
                                          setFileBoleto(e.target.files[0])
                                        }
                                      />
                                      <FormErrorMessage fontWeight="500">
                                        * Tipos de arquivos permitidos (PDF,
                                        JPEG, PNG, IMG, DOCX, DOC, XLSX, XLS,
                                        CSV, RAR, ZIP)
                                      </FormErrorMessage>
                                    </FormControl>

                                    <FormControl
                                      isRequired
                                      isInvalid={
                                        fileBoleto || fileNota
                                          ? fileNota?.name.split(".")[1] ===
                                              "png" ||
                                            fileNota?.name.split(".")[1] ===
                                              "jpg" ||
                                            fileNota?.name.split(".")[1] ===
                                              "jpeg" ||
                                            fileNota?.name.split(".")[1] ===
                                              "zip" ||
                                            fileNota?.name.split(".")[1] ===
                                              "pdf" ||
                                            fileNota?.name.split(".")[1] ===
                                              "img" ||
                                            fileNota?.name.split(".")[1] ===
                                              "docx" ||
                                            fileNota?.name.split(".")[1] ===
                                              "doc" ||
                                            fileNota?.name.split(".")[1] ===
                                              "xlsx" ||
                                            fileNota?.name.split(".")[1] ===
                                              "xls" ||
                                            fileNota?.name.split(".")[1] ===
                                              "csv" ||
                                            fileNota?.name.split(".")[1] ===
                                              "rar"
                                            ? false
                                            : true
                                          : false
                                      }
                                    >
                                      <FormLabel htmlFor="nota">
                                        Arquivo da nota
                                      </FormLabel>
                                      <Input
                                        color="blue.600"
                                        padding="5px"
                                        id="nota"
                                        name="nota"
                                        type="file"
                                        onChange={(e: any) =>
                                          setFileNota(e.target.files[0])
                                        }
                                      />
                                      <FormErrorMessage fontWeight="500">
                                        * Tipos de arquivos permitidos (PDF,
                                        JPEG, PNG, IMG, DOCX, DOC, XLSX, XLS,
                                        CSV, RAR, ZIP)
                                      </FormErrorMessage>
                                    </FormControl>

                                    <Button
                                      colorScheme="blue"
                                      isLoading={isSending}
                                      type="submit"
                                      disabled={
                                        fileBoleto === null ||
                                        fileNota === null ||
                                        (fileBoleto?.name.split(".")[1] ===
                                          "png" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "jpg" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "jpeg" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "zip" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "pdf" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "img" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "docx" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "doc" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "xlsx" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "xls" ||
                                        fileBoleto?.name.split(".")[1] ===
                                          "csv" ||
                                        fileBoleto?.name.split(".")[1] === "rar"
                                          ? false
                                          : true) ||
                                        (fileNota?.name.split(".")[1] ===
                                          "png" ||
                                        fileNota?.name.split(".")[1] ===
                                          "jpg" ||
                                        fileNota?.name.split(".")[1] ===
                                          "jpeg" ||
                                        fileNota?.name.split(".")[1] ===
                                          "zip" ||
                                        fileNota?.name.split(".")[1] ===
                                          "pdf" ||
                                        fileNota?.name.split(".")[1] ===
                                          "img" ||
                                        fileNota?.name.split(".")[1] ===
                                          "docx" ||
                                        fileNota?.name.split(".")[1] ===
                                          "doc" ||
                                        fileNota?.name.split(".")[1] ===
                                          "xlsx" ||
                                        fileNota?.name.split(".")[1] ===
                                          "xls" ||
                                        fileNota?.name.split(".")[1] ===
                                          "csv" ||
                                        fileNota?.name.split(".")[1] === "rar"
                                          ? false
                                          : true)
                                      }
                                    >
                                      Enviar
                                    </Button>
                                  </Grid>
                                </form>
                              </ModalBody>
                              <ModalFooter></ModalFooter>
                            </>
                          ) : click && click === "observacao" && observacao ? (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status={
                                    observacao.status_documento?.id === 2
                                      ? "info"
                                      : observacao.status_documento?.id === 3
                                      ? "error"
                                      : observacao.status_documento?.id === 4
                                      ? "success"
                                      : "warning"
                                  }
                                >
                                  <AlertIcon />
                                  {observacao.status_documento?.id === 2
                                    ? "Enviado. Aguardando validação"
                                    : observacao.status_documento?.id === 3
                                    ? "Negado. Aguardando reenvio"
                                    : observacao.status_documento?.id === 4
                                    ? "Validado"
                                    : "Não enviado"}
                                </Alert>
                                <Divider />
                                <Box
                                  fontSize="14px"
                                  fontWeight="500"
                                  display="flex"
                                  gridColumnGap="20px"
                                  justifyContent="space-between"
                                >
                                  <Text>
                                    Usuário:{" "}
                                    {observacao.users_permissions_user?.nome}
                                  </Text>
                                  <Text>
                                    Data:{" "}
                                    {moment(observacao.updated_at).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>
                                  <Text>
                                    Hora:{" "}
                                    {moment(observacao.updated_at).format(
                                      "HH:mm",
                                    )}
                                  </Text>
                                </Box>
                                <Box
                                  fontSize="14px"
                                  fontWeight="500"
                                  display="flex"
                                  gridColumnGap="20px"
                                >
                                  <Text>
                                    Fatura: {observacao?.nome_arquivo}
                                  </Text>
                                </Box>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <Text
                                  backgroundColor="#f2f2f2"
                                  textAlign="center"
                                  fontSize="18px"
                                  padding="20px 10px"
                                  marginBottom="15px"
                                >
                                  {observacao.observacao}
                                </Text>
                              </ModalBody>
                            </>
                          ) : click &&
                            click === "observacaoPendencia" &&
                            observacao ? (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status="info"
                                >
                                  <AlertIcon />
                                  Validado com pendência
                                </Alert>
                                <Divider />
                                <Box
                                  fontSize="14px"
                                  fontWeight="500"
                                  display="flex"
                                  gridColumnGap="20px"
                                  justifyContent="space-between"
                                >
                                  <Text>
                                    Usuário:{" "}
                                    {
                                      observacao.hist_validacao_docs.find(
                                        (hist: any) =>
                                          hist.status_documento?.id === 8,
                                      ).users_permissions_user?.nome
                                    }
                                  </Text>
                                  <Text>
                                    Data:{" "}
                                    {moment(observacao.updated_at).format(
                                      "DD/MM/YYYY",
                                    )}
                                  </Text>
                                  <Text>
                                    Hora:{" "}
                                    {moment(observacao.updated_at).format(
                                      "HH:mm",
                                    )}
                                  </Text>
                                </Box>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <Text
                                  backgroundColor="#f2f2f2"
                                  textAlign="center"
                                  fontSize="18px"
                                  padding="20px 10px"
                                  marginBottom="15px"
                                  border="1px solid #E53E3E"
                                >
                                  {
                                    observacao.hist_validacao_docs.find(
                                      (hist: any) =>
                                        hist.status_documento?.id === 8,
                                    ).observacao
                                  }
                                </Text>
                              </ModalBody>
                            </>
                          ) : click && click === "expirado" && observacao ? (
                            <>
                              <ModalHeader>
                                <Alert
                                  padding="5px"
                                  backgroundColor="unset"
                                  status="warning"
                                >
                                  <AlertIcon />
                                  Não validado
                                </Alert>
                                <Text fontSize="17px" marginLeft="37px">
                                  {observacao.fl_envia_pos_limite
                                    ? "Arquivo de extrato liberado para validação"
                                    : "Arquivo de extrato bloqueado para validação"}
                                </Text>
                                <Divider />
                              </ModalHeader>
                              <ModalCloseButton />
                              <ModalBody>
                                <Text
                                  fontSize="18px"
                                  padding="0 10px"
                                  marginBottom="15px"
                                >
                                  Contrato:{" "}
                                  <b>{observacao.contrato.desc_contrato}</b>
                                </Text>
                                <Text
                                  fontSize="18px"
                                  padding="0 10px"
                                  marginBottom="15px"
                                >
                                  Data limite:{" "}
                                  <b>
                                    {moment(
                                      `${observacao.ano_competencia}-${observacao.mes_competencia}-${observacao.contrato.dia_limite_ext_bol_not}`,
                                    ).format("DD/MM/YYYY")}
                                  </b>
                                </Text>
                                <Divider marginBottom="15px" />
                                <FormControl
                                  display="flex"
                                  padding="0 10px"
                                  marginBottom="15px"
                                  fontSize="18px"
                                >
                                  <FormLabel
                                    htmlFor="changeSend"
                                    fontSize="18px"
                                  >
                                    Deseja{" "}
                                    {observacao.fl_envia_pos_limite
                                      ? "bloquear"
                                      : "liberar"}{" "}
                                    para validação?
                                  </FormLabel>
                                  <Switch
                                    paddingTop="3px"
                                    onChange={() => setChangeSend(!changeSend)}
                                    id="changeSend"
                                    style={{ outline: "0 !important" }}
                                  />
                                  <Text marginLeft="10px">
                                    {changeSend ? "Sim" : "Não"}
                                  </Text>
                                </FormControl>
                                <Box
                                  display="flex"
                                  justifyContent="end"
                                  marginBottom="15px"
                                >
                                  <Button
                                    fontWeight="500"
                                    colorScheme="blue"
                                    isLoading={isSending}
                                    onClick={() =>
                                      sendRelease(
                                        observacao.fl_envia_pos_limite,
                                      )
                                    }
                                    disabled={!changeSend}
                                  >
                                    {observacao.fl_envia_pos_limite
                                      ? "Bloquear"
                                      : "Liberar"}{" "}
                                  </Button>
                                </Box>
                              </ModalBody>
                            </>
                          ) : (
                            click &&
                            click === "enviado" &&
                            observacao && (
                              <>
                                <ModalHeader>
                                  <Alert
                                    padding="5px"
                                    backgroundColor="unset"
                                    status="info"
                                  >
                                    <AlertIcon />
                                    {observacao.fl_validando_ext_bol_not
                                      ? "Enviado. Em validação"
                                      : "Enviado. Aguardando validação"}
                                  </Alert>
                                  <Divider />
                                </ModalHeader>
                                <ModalCloseButton />
                                <ModalBody>
                                  <Text
                                    backgroundColor="#f2f2f2"
                                    textAlign="center"
                                    fontSize="18px"
                                    padding="20px 10px"
                                    marginBottom="15px"
                                  >
                                    Olá {user?.nome}, a contratante esta
                                    validando a competência, aguarde a resposta.
                                  </Text>
                                </ModalBody>
                              </>
                            )
                          )}
                        </ModalContent>
                      </Modal>
                    </>
                  )}
                </>
              ) : (
                selectedContract &&
                select &&
                !pageLoading && (
                  <Alert
                    status="info"
                    fontSize="18px"
                    marginTop={mobile ? "40px" : 0}
                    fontWeight="500"
                  >
                    {vigenciaContratoAtivo ? (
                      <>
                        <AlertIcon />A primeira competência será disponibilizada
                        em {vigenciaContrato}.
                      </>
                    ) : (
                      <>
                        <AlertIcon />
                        Contrato encerrado antes da primeira competência ser
                        disponibilizada.
                      </>
                    )}
                  </Alert>
                )
              )}
            </>
          )}
        </Box>
      </>
    )
  );
};

export default Cobranca;
